module.exports = {
  "RecordStatus": {
    "ACTIVE": "ACTIVE",
    "INACTIVE": "INACTIVE"
  },
  "ActionStatus": {
    "FAILURE": "FAILURE",
    "SUCCESS": "SUCCESS"
  },
  "Origin": {
    "TRINITY": "TRINITY",
    "MLH": "MLH",
    "STRATEGY": "STRATEGY",
    "MORPHEUS": "MORPHEUS",
    "REAL_AUCTION": "REAL_AUCTION",
    "TRUSTEE_WEB_SERVICE": "TRUSTEE_WEB_SERVICE",
    "BIDDING_ENGINE": "BIDDING_ENGINE",
    "AUCTION_SYNC": "AUCTION_SYNC",
    "ATTORNEY": "ATTORNEY"
  },
  "TenboxFileDescriptorStatus": {
    "DELETED": "DELETED",
    "FAILED": "FAILED",
    "PENDING": "PENDING",
    "PURGED": "PURGED",
    "READY": "READY"
  },
  "PropertyStructureType": {
    "SINGLE_FAMILY_HOME": "SINGLE_FAMILY_HOME",
    "SINGLE_FAMILY_ATTACHED": "SINGLE_FAMILY_ATTACHED",
    "SINGLE_FAMILY_DETACHED": "SINGLE_FAMILY_DETACHED",
    "CONDOMINIUM_UNIT": "CONDOMINIUM_UNIT",
    "TOWNHOUSE": "TOWNHOUSE",
    "HI_RISE_CONDO_UNIT": "HI_RISE_CONDO_UNIT",
    "COOP_UNIT": "COOP_UNIT",
    "DUPLEX_UNIT": "DUPLEX_UNIT",
    "MULTI_UNIT_BUILDING": "MULTI_UNIT_BUILDING",
    "MANUFACTURED_HOME": "MANUFACTURED_HOME",
    "MOBILE_HOME": "MOBILE_HOME",
    "PUD_HOME": "PUD_HOME",
    "OTHER": "OTHER",
    "FOUR_PLEX_BUILDING": "FOUR_PLEX_BUILDING",
    "APARTMENT_UNIT": "APARTMENT_UNIT",
    "APARTMENT_BUILDING": "APARTMENT_BUILDING",
    "APARTMENT_COMPLEX": "APARTMENT_COMPLEX",
    "FOUR_PLEX_UNIT": "FOUR_PLEX_UNIT",
    "THREE_PLEX_UNIT": "THREE_PLEX_UNIT",
    "ATTACHED_GARAGE": "ATTACHED_GARAGE",
    "COOP_BUILDING": "COOP_BUILDING",
    "CONDOMINIUM_BUILDING": "CONDOMINIUM_BUILDING",
    "DETACHED_GARAGE": "DETACHED_GARAGE",
    "DUPLEX_BUILDING": "DUPLEX_BUILDING",
    "FLOOR": "FLOOR",
    "MODULAR_HOME": "MODULAR_HOME",
    "STUDIO": "STUDIO",
    "LAND": "LAND",
    "LOFT": "LOFT",
    "THREE_PLEX_BUILDING": "THREE_PLEX_BUILDING"
  },
  "SortConditionOrder": {
    "ASC": "ASC",
    "DESC": "DESC"
  },
  "ResolvePolicy": {
    "CACHE_AND_ORIGIN": "CACHE_AND_ORIGIN",
    "CACHE_ONLY": "CACHE_ONLY",
    "ORIGIN_ONLY": "ORIGIN_ONLY"
  },
  "ReviewableResourceStatus": {
    "HAS_PENDING_REVIEWS": "HAS_PENDING_REVIEWS",
    "NO_PENDING_REVIEWS": "NO_PENDING_REVIEWS"
  },
  "CurrentTargetAudience": {
    "BUYER": "BUYER",
    "SELLER": "SELLER",
    "STAFF": "STAFF"
  },
  "SupportedLineOfBusiness": {
    "REO": "REO",
    "FCL": "FCL",
    "PVT": "PVT"
  },
  "DomainEventTypeName": {
    "DEBUG__TRIGGERED": "DEBUG__TRIGGERED",
    "LISTING_CARD__CLICKED": "LISTING_CARD__CLICKED",
    "SEARCH_RESULTS_PAGE__FILTER_CHANGED": "SEARCH_RESULTS_PAGE__FILTER_CHANGED",
    "SEARCH_RESULTS_PAGE__RESPONSE_RECEIVED": "SEARCH_RESULTS_PAGE__RESPONSE_RECEIVED",
    "PAGE__VIEWED": "PAGE__VIEWED"
  },
  "SessionHandoffTarget": {
    "AUCTIONCOM": "AUCTIONCOM",
    "SMARTSALE": "SMARTSALE"
  },
  "OTPDeliveryMechanism": {
    "SMS": "SMS",
    "CALL": "CALL"
  },
  "PartyAuthorizationAction": {
    "EDIT_PHONE": "EDIT_PHONE"
  },
  "UserType": {
    "AGENT": "AGENT",
    "NONAGENT": "NONAGENT"
  },
  "UserStatus": {
    "PENDING": "PENDING",
    "CONFIRMED": "CONFIRMED",
    "SUSPENDED": "SUSPENDED",
    "INACTIVE": "INACTIVE"
  },
  "SavedSearchSource": {
    "ALL": "ALL",
    "ADC": "ADC",
    "MORPHEUS": "MORPHEUS"
  },
  "UserAuthorizationAction": {
    "EDIT_EMAIL": "EDIT_EMAIL"
  },
  "InvitationRelativeType": {
    "LISTING": "LISTING"
  },
  "SupportedInvitationPartyRole": {
    "PRIVATE_SELLER": "PRIVATE_SELLER",
    "LISTING_AGENT": "LISTING_AGENT"
  },
  "InvitationIntent": {
    "NEW_ACCOUNT": "NEW_ACCOUNT",
    "CONTRACTING_LISTING": "CONTRACTING_LISTING",
    "CONSUMER_LISTING_CREATION": "CONSUMER_LISTING_CREATION",
    "CONSUMER_LISTING_PARTY_ASSOCIATION": "CONSUMER_LISTING_PARTY_ASSOCIATION"
  },
  "InvitationStatus": {
    "PENDING": "PENDING",
    "ACCEPTED": "ACCEPTED",
    "DECLINED": "DECLINED",
    "REVOKED": "REVOKED",
    "EXPIRED": "EXPIRED"
  },
  "InvitationFilterPartyRole": {
    "RECIPIENT": "RECIPIENT",
    "SENDER": "SENDER"
  },
  "OnlineAuctionPersonaType": {
    "NOVICE": "NOVICE",
    "BIDDER": "BIDDER",
    "BUYER": "BUYER"
  },
  "SellerPersonaType": {
    "NOVICE": "NOVICE",
    "SELLER": "SELLER",
    "TRUSTED_SELLER": "TRUSTED_SELLER"
  },
  "ClosingRelationship": {
    "BUYER": "BUYER",
    "COBUYER": "COBUYER",
    "BUYER_AGENT": "BUYER_AGENT",
    "LISTING_AGENT": "LISTING_AGENT",
    "ESCROW_COMPANY": "ESCROW_COMPANY",
    "LENDER": "LENDER",
    "BIDDER": "BIDDER",
    "AUDITOR": "AUDITOR",
    "TRANSACTION_COORDINATOR": "TRANSACTION_COORDINATOR",
    "WINNING_BIDDER": "WINNING_BIDDER",
    "SELLER": "SELLER"
  },
  "TrusteeContractExpectedPaymentReason": {
    "STATE_DEPOSIT": "STATE_DEPOSIT"
  },
  "TrusteeContractFileType": {
    "WITNESS_SIGNATURE": "WITNESS_SIGNATURE",
    "BUYER_SIGNATURE": "BUYER_SIGNATURE"
  },
  "TrusteeContractCheckFileType": {
    "FRONT": "FRONT",
    "BACK": "BACK"
  },
  "TrusteeContractFundType": {
    "CASH": "CASH",
    "HARD_MONEY_LOAN": "HARD_MONEY_LOAN",
    "CHECK": "CHECK",
    "WIRE": "WIRE",
    "LINE_OF_CREDIT": "LINE_OF_CREDIT",
    "FINANCE": "FINANCE",
    "OTHER": "OTHER"
  },
  "BidderType": {
    "LIVE": "LIVE",
    "ONLINE": "ONLINE",
    "PROXY_BIDDER": "PROXY_BIDDER",
    "UPSET": "UPSET"
  },
  "CustomerType": {
    "OWNER": "OWNER",
    "REPRESENTATIVE": "REPRESENTATIVE"
  },
  "PhoneType": {
    "HOME": "HOME",
    "OFFICE": "OFFICE",
    "MOBILE": "MOBILE",
    "FAX": "FAX"
  },
  "RefundPayableTo": {
    "REPRESENTATIVE": "REPRESENTATIVE",
    "OWNER": "OWNER",
    "MANUAL": "MANUAL",
    "OTHER": "OTHER",
    "UNKNOWN": "UNKNOWN"
  },
  "DeedMailingAddressTo": {
    "REPRESENTATIVE": "REPRESENTATIVE",
    "OWNER": "OWNER",
    "MANUAL": "MANUAL",
    "OTHER": "OTHER",
    "UNKNOWN": "UNKNOWN"
  },
  "TrusteeContractStatus": {
    "OPEN": "OPEN",
    "CLOSED": "CLOSED"
  },
  "ExternalBidderSourceType": {
    "UAA": "UAA",
    "EXTERNAL": "EXTERNAL",
    "UNSPECIFIED": "UNSPECIFIED"
  },
  "PayableTo": {
    "ADC": "ADC",
    "TRUSTEE": "TRUSTEE",
    "OTHER": "OTHER"
  },
  "TrusteeContractAutomationStatus": {
    "NOT_ATTEMPTED": "NOT_ATTEMPTED",
    "SUCCESSFUL": "SUCCESSFUL",
    "FAILURE": "FAILURE"
  },
  "TrusteeContractNotificationType": {
    "CERTIFICATE_OF_SALE": "CERTIFICATE_OF_SALE"
  },
  "TrusteeContractCertificateType": {
    "CERTIFICATE_OF_SALES": "CERTIFICATE_OF_SALES",
    "CONTRACT_PACKAGE": "CONTRACT_PACKAGE",
    "REVERT_CERTIFICATE": "REVERT_CERTIFICATE",
    "POSTPONEMENT_CERTIFICATE": "POSTPONEMENT_CERTIFICATE"
  },
  "TrusteeContractAuditSourceType": {
    "AUCTION_SYNC": "AUCTION_SYNC",
    "TRANSACTION_MANAGER": "TRANSACTION_MANAGER",
    "SYSTEM": "SYSTEM"
  },
  "ReoOfferStatus": {
    "NEW": "NEW",
    "IN_PROGRESS": "IN_PROGRESS",
    "REVIEW": "REVIEW",
    "CONTRACT_SENT": "CONTRACT_SENT",
    "CONTRACT_RECEIVED": "CONTRACT_RECEIVED",
    "COMPLETE": "COMPLETE"
  },
  "ReoOfferCertifiedBuyerType": {
    "OWNER_OCCUPANT": "OWNER_OCCUPANT",
    "BUYER_NOT_QUALIFIED": "BUYER_NOT_QUALIFIED",
    "HUD_APPROVED_NON_PROFIT": "HUD_APPROVED_NON_PROFIT",
    "GOVERNMENT_ENTITY": "GOVERNMENT_ENTITY",
    "NON_PROFIT": "NON_PROFIT",
    "INVESTOR": "INVESTOR",
    "STATE_REQUIRED_NON_PROFIT": "STATE_REQUIRED_NON_PROFIT",
    "STATE_COMMUNITY_LAND_TRUST": "STATE_COMMUNITY_LAND_TRUST",
    "STATE_LTD_EQUITY_HOUSING_CORP": "STATE_LTD_EQUITY_HOUSING_CORP",
    "STATE_AGENCY": "STATE_AGENCY"
  },
  "ReoOfferRealEstateAgentType": {
    "NONE": "NONE",
    "AGENT": "AGENT",
    "SELF": "SELF"
  },
  "ShallowTaskWorkflowItemExpectation": {
    "MANDATORY": "MANDATORY",
    "ENCOURAGED": "ENCOURAGED",
    "OPTIONAL": "OPTIONAL"
  },
  "ShallowTaskWorkflowItemStatus": {
    "COMPLETE": "COMPLETE",
    "ONGOING": "ONGOING",
    "UPCOMING": "UPCOMING"
  },
  "ReoOfferDocumentRecipientType": {
    "SIGNER": "SIGNER",
    "AGENT": "AGENT",
    "EDITOR": "EDITOR",
    "INTERMEDIARY": "INTERMEDIARY",
    "CARBON_COPY": "CARBON_COPY",
    "CERTIFIED_DELIVERY": "CERTIFIED_DELIVERY",
    "IN_PERSON_SIGNER": "IN_PERSON_SIGNER",
    "SIGNING_HOST": "SIGNING_HOST",
    "INVALID": "INVALID"
  },
  "FalloutCausedBy": {
    "SELLER": "SELLER",
    "BUYER": "BUYER",
    "PROPERTY": "PROPERTY",
    "ADC": "ADC"
  },
  "ReoContractMediaFileType": {
    "PREVIEW": "PREVIEW",
    "SAMPLE": "SAMPLE",
    "UNSIGNED_CONTRACT": "UNSIGNED_CONTRACT",
    "SIGNED_CONTRACT": "SIGNED_CONTRACT",
    "SELLER_SIGNED_CONTRACT": "SELLER_SIGNED_CONTRACT",
    "ADDENDUM": "ADDENDUM",
    "AMENDED_CONTRACT_UNSIGNED": "AMENDED_CONTRACT_UNSIGNED",
    "AMENDED_CONTRACT_SIGNED": "AMENDED_CONTRACT_SIGNED",
    "AMENDED_ADDENDUM": "AMENDED_ADDENDUM",
    "INTERNAL_PREVIEW": "INTERNAL_PREVIEW",
    "INTERNAL_UNSIGNED_CONTRACT": "INTERNAL_UNSIGNED_CONTRACT",
    "INTERNAL_SIGNED_CONTRACT": "INTERNAL_SIGNED_CONTRACT",
    "INTERNAL_SELLER_SIGNED_CONTRACT": "INTERNAL_SELLER_SIGNED_CONTRACT",
    "EXTENSION_UNSIGNED": "EXTENSION_UNSIGNED",
    "EXTENSION_SIGNED": "EXTENSION_SIGNED",
    "CANCELLATION_UNSIGNED": "CANCELLATION_UNSIGNED",
    "CANCELLATION_SIGNED": "CANCELLATION_SIGNED",
    "TRANSACTION_DETAILS_SHEET": "TRANSACTION_DETAILS_SHEET",
    "PROOF_OF_FUNDS": "PROOF_OF_FUNDS",
    "ESTIMATED_HUD": "ESTIMATED_HUD",
    "FINAL_HUD": "FINAL_HUD",
    "CLOSING_REPORT": "CLOSING_REPORT",
    "MISC_CLOSING_DOC": "MISC_CLOSING_DOC",
    "INVALID": "INVALID"
  },
  "ReoContractDocumentGenerationProcessCode": {
    "ONLY_MCDS_ENABLED": "ONLY_MCDS_ENABLED",
    "ONLY_INTERNAL_ENABLED": "ONLY_INTERNAL_ENABLED",
    "MCDS_AND_INTERNAL_ENABLED": "MCDS_AND_INTERNAL_ENABLED",
    "NO_CONTRACTING_ENABLED": "NO_CONTRACTING_ENABLED"
  },
  "ReoOfferPurchaseType": {
    "INVESTMENT": "INVESTMENT",
    "PRIMARY": "PRIMARY",
    "SECONDARY": "SECONDARY"
  },
  "ReoOfferExtensionServicerDecision": {
    "APPROVED": "APPROVED",
    "REJECTED": "REJECTED",
    "MODIFIED": "MODIFIED",
    "PENDING": "PENDING"
  },
  "ReoOfferExtensionReason": {
    "BUYER_DELAY": "BUYER_DELAY",
    "CLOSER_ESCROW_DELAY": "CLOSER_ESCROW_DELAY",
    "LENDER_DELAY": "LENDER_DELAY",
    "LIENS_DEMANDS_DELAY": "LIENS_DEMANDS_DELAY",
    "PROPERTY_ISSUES": "PROPERTY_ISSUES",
    "SELLER_DELAY": "SELLER_DELAY"
  },
  "ReoOfferExtensionAdditionalDetails": {
    "APPROVAL_TO_PAY_FEES": "APPROVAL_TO_PAY_FEES",
    "APPROVAL_TO_PAY_REPAIRS": "APPROVAL_TO_PAY_REPAIRS",
    "DEMAND_ISSUE": "DEMAND_ISSUE",
    "ESCALATION": "ESCALATION",
    "HOA_ISSUES_DELAY": "HOA_ISSUES_DELAY",
    "LIEN_ISSUE": "LIEN_ISSUE",
    "TIMELINE_AT_CONTRACT_EXECUTION": "TIMELINE_AT_CONTRACT_EXECUTION",
    "FORECLOSURE_DEED_NOT_RECORDED": "FORECLOSURE_DEED_NOT_RECORDED",
    "INSPECTIONS": "INSPECTIONS",
    "OTHER": "OTHER",
    "REPAIR_COMPLETION": "REPAIR_COMPLETION",
    "TITLE_CURATIVE": "TITLE_CURATIVE",
    "LENDER_FINANCING_DELAY": "LENDER_FINANCING_DELAY"
  },
  "ReoCancellationReason": {
    "BUYER_TERMINATION": "BUYER_TERMINATION",
    "BUYER_NON_PERFORMANCE": "BUYER_NON_PERFORMANCE",
    "TITLE_COMPANY_PERFORMANCE": "TITLE_COMPANY_PERFORMANCE",
    "SELLER_TERMINATION": "SELLER_TERMINATION",
    "SHORT_SALE_ISSUE": "SHORT_SALE_ISSUE"
  },
  "ReoCancellationAdditionalDetails": {
    "ASSET_CONVEYANCE": "ASSET_CONVEYANCE",
    "ASSET_REMOVED": "ASSET_REMOVED",
    "ASSET_TYPE": "ASSET_TYPE",
    "BUYER_ASSIGNED": "BUYER_ASSIGNED",
    "BUYER_BREACH_OF_CONTRACT": "BUYER_BREACH_OF_CONTRACT",
    "BUYER_NON_RESPONSIVE": "BUYER_NON_RESPONSIVE",
    "BUYER_WALKED": "BUYER_WALKED",
    "BUYER_NOT_QUALIFIED_FOR_FIRST_LOOK": "BUYER_NOT_QUALIFIED_FOR_FIRST_LOOK",
    "CHANGE_IN_OCCUPANCY_STATUS": "CHANGE_IN_OCCUPANCY_STATUS",
    "CO_OP_DENIAL_DELAY": "CO_OP_DENIAL_DELAY",
    "CONTRACT_ISSUES": "CONTRACT_ISSUES",
    "DELAY_IN_SHORT_SALE_OFFER_APPROVAL": "DELAY_IN_SHORT_SALE_OFFER_APPROVAL",
    "EMD_NOT_DEPOSITED": "EMD_NOT_DEPOSITED",
    "EMERGENCY": "EMERGENCY",
    "FINAL_ACQUISITION_OF_THE_PROPERTY_BY_THE_SELLER": "FINAL_ACQUISITION_OF_THE_PROPERTY_BY_THE_SELLER",
    "FINANCING_FAILED": "FINANCING_FAILED",
    "FORECLOSURE_DEED_NOT_RECORDED": "FORECLOSURE_DEED_NOT_RECORDED",
    "FORECLOSURE_ON_HOLD": "FORECLOSURE_ON_HOLD",
    "FUNDS_TO_CLOSE": "FUNDS_TO_CLOSE",
    "HOA_RESTRICTION_OR_ISSUES": "HOA_RESTRICTION_OR_ISSUES",
    "HAZARDOUS_CONDITIONS": "HAZARDOUS_CONDITIONS",
    "IF_REQUIRED_BY_SELLER_THE_REPURCHASE_OF_THE_PROPERTY_BY_THE_PRIOR_MORTGAGE_SERVICER_FROM_SELLER": "IF_REQUIRED_BY_SELLER_THE_REPURCHASE_OF_THE_PROPERTY_BY_THE_PRIOR_MORTGAGE_SERVICER_FROM_SELLER",
    "INSPECTION_ISSUES": "INSPECTION_ISSUES",
    "OCCUPANT_DENIED_INSPECTION": "OCCUPANT_DENIED_INSPECTION",
    "OFFER_REJECTED_BY_BORROWER_SELLER": "OFFER_REJECTED_BY_BORROWER_SELLER",
    "OFFER_REJECTED_BY_SERVICER": "OFFER_REJECTED_BY_SERVICER",
    "OTHER": "OTHER",
    "POS_INSPECTION_ISSUES": "POS_INSPECTION_ISSUES",
    "PENDING_LITIGATION": "PENDING_LITIGATION",
    "PROPERTY_CONDITION_INSPECTION": "PROPERTY_CONDITION_INSPECTION",
    "PROPERTY_ISSUES": "PROPERTY_ISSUES",
    "RE_ENTER_SALE_TERMS": "RE_ENTER_SALE_TERMS",
    "REDEMPTION_PERIOD": "REDEMPTION_PERIOD",
    "REFORECLOSURE": "REFORECLOSURE",
    "RIGHT_OF_FIRST_REFUSAL_BY_COA_HOA_CO_OP": "RIGHT_OF_FIRST_REFUSAL_BY_COA_HOA_CO_OP",
    "RIGHT_OF_REDEMPTION": "RIGHT_OF_REDEMPTION",
    "SELLER_ASSIGNED": "SELLER_ASSIGNED",
    "SELLER_REJECTED_REQUEST_TO_COMPLETE_REPAIRS": "SELLER_REJECTED_REQUEST_TO_COMPLETE_REPAIRS",
    "SELLER_REJECTED_REQUEST_TO_EXTEND_CLOSING": "SELLER_REJECTED_REQUEST_TO_EXTEND_CLOSING",
    "TERMS_OF_LEASE": "TERMS_OF_LEASE",
    "THE_ABILITY_OF_SELLER_TO_PROVIDE_INSURABLE_TITLE": "THE_ABILITY_OF_SELLER_TO_PROVIDE_INSURABLE_TITLE",
    "THE_MORTGAGE_INSURANCE_COMPANYS_APPROVAL_OF_THE_SALE": "THE_MORTGAGE_INSURANCE_COMPANYS_APPROVAL_OF_THE_SALE",
    "TITLE_ISSUES": "TITLE_ISSUES",
    "UNCOOPERATIVE_OCCUPANT": "UNCOOPERATIVE_OCCUPANT",
    "WEATHER_DISASTER": "WEATHER_DISASTER",
    "WEATHER_DISASTER_AFFECTED_PROPERTY": "WEATHER_DISASTER_AFFECTED_PROPERTY",
    "WINNING_BID_DISPUTE": "WINNING_BID_DISPUTE"
  },
  "ReoOfferCancellationServicerDecision": {
    "APPROVED": "APPROVED",
    "REJECTED": "REJECTED",
    "MODIFIED": "MODIFIED",
    "PENDING": "PENDING"
  },
  "ReoOfferOwningEntityType": {
    "INDIVIDUAL": "INDIVIDUAL",
    "COBUYER": "COBUYER",
    "ENTITY": "ENTITY",
    "TRUST": "TRUST",
    "RETIREMENT_PLAN": "RETIREMENT_PLAN"
  },
  "ReoOfferOwningEntitySubType": {
    "COBUYER": "COBUYER",
    "CORPORATION": "CORPORATION",
    "GENERAL_PARTNERSHIP": "GENERAL_PARTNERSHIP",
    "INDIVIDUAL": "INDIVIDUAL",
    "IRA": "IRA",
    "LIMITED_PARTNERSHIP": "LIMITED_PARTNERSHIP",
    "LLC": "LLC",
    "LTD_LIABILITY_PARTNERSHIP": "LTD_LIABILITY_PARTNERSHIP",
    "PENSION_PLAN": "PENSION_PLAN",
    "RETIREMENT_401K": "RETIREMENT_401K",
    "SERIES_LLC": "SERIES_LLC",
    "TRUST": "TRUST"
  },
  "ReoOfferLendingStatus": {
    "CASH_NOT_IE": "CASH_NOT_IE",
    "CASH_IE": "CASH_IE",
    "PREQUALIFIED": "PREQUALIFIED",
    "PENDING_APPRAISAL_DOCS": "PENDING_APPRAISAL_DOCS",
    "SUBMITTED_TO_UW": "SUBMITTED_TO_UW",
    "APPROVED_WITH_CONDITIONS": "APPROVED_WITH_CONDITIONS",
    "APPROVED": "APPROVED",
    "DOCS_ORDERED": "DOCS_ORDERED",
    "DOCS_OUT": "DOCS_OUT",
    "DOCS_BACK": "DOCS_BACK",
    "FUNDED": "FUNDED",
    "DENIED": "DENIED"
  },
  "ReoOfferVestingType": {
    "INDIVIDUAL": "INDIVIDUAL",
    "JOINT_TENANTS": "JOINT_TENANTS",
    "TENANTS_BY_ENTIRETIES": "TENANTS_BY_ENTIRETIES",
    "TENANTS_IN_COMMON": "TENANTS_IN_COMMON",
    "COMMUNITY_PROPERTY": "COMMUNITY_PROPERTY",
    "ENTITY": "ENTITY",
    "SOLE_AND_SEPARATE": "SOLE_AND_SEPARATE",
    "COMMUNITY_PROPERTY_ROS": "COMMUNITY_PROPERTY_ROS",
    "SOLE_OWNERSHIP": "SOLE_OWNERSHIP",
    "OTHER": "OTHER"
  },
  "ReoOfferBuyerOccupancyCode": {
    "INVESTMENT": "INVESTMENT",
    "OWNER_OCCUPIED": "OWNER_OCCUPIED",
    "SECOND_HOME": "SECOND_HOME"
  },
  "MaritalStatus": {
    "SINGLE_MAN": "SINGLE_MAN",
    "SINGLE_WOMAN": "SINGLE_WOMAN",
    "UNMARRIED_MAN": "UNMARRIED_MAN",
    "UNMARRIED_WOMAN": "UNMARRIED_WOMAN",
    "WIDOWER": "WIDOWER",
    "WIDOW": "WIDOW",
    "MARRIED_MAN": "MARRIED_MAN",
    "MARRIED_WOMAN": "MARRIED_WOMAN",
    "HUSBAND_AND_WIFE": "HUSBAND_AND_WIFE",
    "WIFE_AND_HUSBAND": "WIFE_AND_HUSBAND",
    "WIFE_AND_WIFE": "WIFE_AND_WIFE",
    "HUSBAND_AND_HUSBAND": "HUSBAND_AND_HUSBAND",
    "OTHER": "OTHER"
  },
  "ClosingOverviewProjectionGroupingKey": {
    "TRANSACTION_COORDINATOR": "TRANSACTION_COORDINATOR"
  },
  "BidderUserType": {
    "USER": "USER",
    "PARTIAL_USER": "PARTIAL_USER"
  },
  "LiveAuctionSegmentBidType": {
    "CREDIT": "CREDIT",
    "BENEFICIARY_BID": "BENEFICIARY_BID",
    "NOT_REGISTERED": "NOT_REGISTERED",
    "REGISTERED_USER": "REGISTERED_USER",
    "REMOTE_BID": "REMOTE_BID",
    "OPENING_BID": "OPENING_BID"
  },
  "RescissionReason": {
    "ATTORNEY_ERROR": "ATTORNEY_ERROR",
    "BANKRUPTCY": "BANKRUPTCY",
    "BUYER_NON_PERFORMANCE": "BUYER_NON_PERFORMANCE",
    "COURT_VACATED_ORDER": "COURT_VACATED_ORDER",
    "LOSS_MITIGATION": "LOSS_MITIGATION",
    "REINSTATEMENT": "REINSTATEMENT",
    "SERVICER_REQUEST": "SERVICER_REQUEST",
    "OTHER": "OTHER"
  },
  "AuctionSegmentStatus": {
    "UNSET": "UNSET",
    "STARTED": "STARTED",
    "EXTENDED": "EXTENDED",
    "ENDED": "ENDED",
    "ABORTED": "ABORTED"
  },
  "LiveAuctionSegmentBidEndStatus": {
    "NONE": "NONE",
    "GOING_ONCE": "GOING_ONCE",
    "GOING_TWICE": "GOING_TWICE",
    "FINAL_ASK": "FINAL_ASK",
    "FINALIZING_BID": "FINALIZING_BID",
    "SOLD": "SOLD",
    "NO_SALE": "NO_SALE",
    "SALE_FAILED": "SALE_FAILED",
    "POSTPONED": "POSTPONED",
    "ABORTED": "ABORTED"
  },
  "LiveAuctionSegmentFileType": {
    "AUCTIONEER_SIGNATURE": "AUCTIONEER_SIGNATURE",
    "CRY_RECORDING": "CRY_RECORDING",
    "NOTICE_OF_SALE": "NOTICE_OF_SALE"
  },
  "FalloutReason": {
    "SYSTEM_ISSUE": "SYSTEM_ISSUE",
    "HOA_ISSUES": "HOA_ISSUES",
    "POOR_ONLINE_REVIEWS": "POOR_ONLINE_REVIEWS",
    "TITLE_ISSUES": "TITLE_ISSUES",
    "NATURAL_DISASTER": "NATURAL_DISASTER",
    "PROPERTY_DESCRIPTION": "PROPERTY_DESCRIPTION",
    "RE_CLERK": "RE_CLERK",
    "ENTITY_ISSUES": "ENTITY_ISSUES",
    "NON_PERFORMANCE": "NON_PERFORMANCE",
    "NON_RESPONSIVE": "NON_RESPONSIVE",
    "FAILED_FINANCING": "FAILED_FINANCING",
    "UNACCEPTABLE_POF": "UNACCEPTABLE_POF",
    "PROPERTY_CONDITION": "PROPERTY_CONDITION",
    "BID_TOO_MUCH": "BID_TOO_MUCH",
    "BUYER_PREMIUM_ISSUES": "BUYER_PREMIUM_ISSUES",
    "EMERGENCY": "EMERGENCY",
    "TERMS_AND_CONDITIONS": "TERMS_AND_CONDITIONS",
    "TYPE_OF_ASSET": "TYPE_OF_ASSET",
    "DAMAGE_AFTER_AUCTION": "DAMAGE_AFTER_AUCTION",
    "CLERKING_ERROR": "CLERKING_ERROR",
    "SELLER_REMOVAL": "SELLER_REMOVAL",
    "SELLER_REJECTION": "SELLER_REJECTION",
    "BIDDING_ERROR": "BIDDING_ERROR",
    "BUYER_WALKED": "BUYER_WALKED",
    "ATTORNEY_REQUEST": "ATTORNEY_REQUEST",
    "UPSET_BID": "UPSET_BID",
    "ADC_EVICTION_PLEDGE": "ADC_EVICTION_PLEDGE",
    "FAILED_TO_DISCLOSE": "FAILED_TO_DISCLOSE",
    "SELLER_CANCELLATION": "SELLER_CANCELLATION",
    "SERVICE_RELEASE": "SERVICE_RELEASE",
    "SUSPENDED_BUYER": "SUSPENDED_BUYER",
    "BUYER_NOT_HUD_APPROVED_NON_PROFIT": "BUYER_NOT_HUD_APPROVED_NON_PROFIT",
    "BUYER_NOT_QUALIFIED": "BUYER_NOT_QUALIFIED",
    "GOVERNMENT_ENTITY_NOT_APPROVED": "GOVERNMENT_ENTITY_NOT_APPROVED"
  },
  "ListingPendingUpdateStatus": {
    "SALE_PENDING": "SALE_PENDING",
    "SALE_PENDING_CLEARED": "SALE_PENDING_CLEARED",
    "CANCELED": "CANCELED",
    "POSTPONED": "POSTPONED",
    "NONE": "NONE"
  },
  "PartyBiddingStatus": {
    "NO_BID": "NO_BID",
    "OUTBID": "OUTBID",
    "HIGHEST_BID": "HIGHEST_BID"
  },
  "OnlineAuctionSegmentBidType": {
    "MAX_BID": "MAX_BID",
    "SELLER": "SELLER",
    "REGULAR": "REGULAR",
    "MANUAL": "MANUAL",
    "MATCH": "MATCH",
    "TRADITIONAL_OFFER": "TRADITIONAL_OFFER",
    "SELLER_COUNTER_BID": "SELLER_COUNTER_BID",
    "BUYER_COUNTER_BID": "BUYER_COUNTER_BID"
  },
  "BidsAwayStatus": {
    "NONE": "NONE",
    "ONE_AWAY": "ONE_AWAY",
    "ONE_AWAY_DISPLAYED": "ONE_AWAY_DISPLAYED",
    "TWO_AWAY": "TWO_AWAY",
    "TWO_AWAY_DISPLAYED": "TWO_AWAY_DISPLAYED"
  },
  "OnlineAuctionSegmentStatus": {
    "PENDING": "PENDING",
    "STARTED": "STARTED",
    "SUBJECT_TO_RESERVE_MET": "SUBJECT_TO_RESERVE_MET",
    "RESERVE_MET": "RESERVE_MET",
    "SELLER_REVIEW_PERIOD": "SELLER_REVIEW_PERIOD",
    "HIGHEST_AND_BEST_OPEN": "HIGHEST_AND_BEST_OPEN",
    "HIGHEST_AND_BEST_DECISION": "HIGHEST_AND_BEST_DECISION",
    "ENDED": "ENDED"
  },
  "OnlineAuctionSegmentType": {
    "ENGLISH": "ENGLISH",
    "SEALED_BID": "SEALED_BID"
  },
  "SubjectToStatus": {
    "SELLER_ACCEPTED": "SELLER_ACCEPTED",
    "SELLER_REJECTED": "SELLER_REJECTED",
    "PENDING": "PENDING",
    "CANCELLED": "CANCELLED",
    "OTHERS": "OTHERS",
    "SELLER_COUNTER_OFFERED": "SELLER_COUNTER_OFFERED",
    "NONE": "NONE"
  },
  "ReserveStatus": {
    "RESERVE_MET": "RESERVE_MET",
    "SUBJECT_TO_RESERVE_MET": "SUBJECT_TO_RESERVE_MET",
    "RESERVE_NOT_MET": "RESERVE_NOT_MET"
  },
  "OnlineAuctionSegmentUpdateSource": {
    "MORPHEUS": "MORPHEUS",
    "PIBI": "PIBI",
    "QUAL_DASH": "QUAL_DASH",
    "LISTING_PORTAL": "LISTING_PORTAL"
  },
  "CommissionPayerType": {
    "BUYER": "BUYER",
    "SELLER": "SELLER"
  },
  "OfferorType": {
    "BUYER": "BUYER",
    "BUYERS_AGENT": "BUYERS_AGENT",
    "LISTING_AGENT": "LISTING_AGENT"
  },
  "SealedBidStatus": {
    "UNSET": "UNSET",
    "RE_SUBMITTED": "RE_SUBMITTED",
    "SELLER_ACCEPTED": "SELLER_ACCEPTED",
    "SELLER_REJECTED": "SELLER_REJECTED",
    "SELLER_COUNTERED": "SELLER_COUNTERED",
    "SELLER_COUNTER_EXPIRED": "SELLER_COUNTER_EXPIRED",
    "BUYER_ACCEPTED": "BUYER_ACCEPTED",
    "BUYER_REJECTED": "BUYER_REJECTED",
    "BUYER_COUNTERED": "BUYER_COUNTERED",
    "EXPIRED": "EXPIRED",
    "WITHDRAWN": "WITHDRAWN",
    "SELLER_COUNTER_REJECTED": "SELLER_COUNTER_REJECTED"
  },
  "NoteUpdateReason": {
    "BUYER_UPDATE": "BUYER_UPDATE",
    "AUCTIONEER_OVERWRITE": "AUCTIONEER_OVERWRITE"
  },
  "OnlineAuctionSegmentBidRankingVisibilityLevel": {
    "PUBLIC": "PUBLIC",
    "PARTICIPANTS": "PARTICIPANTS",
    "ALLOW_HIGHER": "ALLOW_HIGHER",
    "ALLOW_HIGHER_OR_EQUAL": "ALLOW_HIGHER_OR_EQUAL"
  },
  "OnlineBidHistoryEntryActionType": {
    "CREATE": "CREATE",
    "UPDATE": "UPDATE",
    "DELETE": "DELETE"
  },
  "SellerAction": {
    "NONE": "NONE",
    "BID_ACCEPTED": "BID_ACCEPTED",
    "BID_ACCEPTED_SUBJECT_TO": "BID_ACCEPTED_SUBJECT_TO",
    "PASSED_ON_BID": "PASSED_ON_BID",
    "RESERVE_CHANGE": "RESERVE_CHANGE",
    "UPDATED_SUBJECT_TO_RESERVE_CHANGE": "UPDATED_SUBJECT_TO_RESERVE_CHANGE"
  },
  "SealedBidProposedTermFieldType": {
    "OFFER_AMOUNT": "OFFER_AMOUNT",
    "PAYMENT_TYPE": "PAYMENT_TYPE",
    "DOWN_PAYMENT_AMOUNT": "DOWN_PAYMENT_AMOUNT",
    "EARNEST_MONEY_DEPOSIT_AMOUNT": "EARNEST_MONEY_DEPOSIT_AMOUNT",
    "CLOSE_ESCROW_DURATION": "CLOSE_ESCROW_DURATION",
    "LEASEBACK_DURATION": "LEASEBACK_DURATION",
    "LEASEBACK_AMOUNT": "LEASEBACK_AMOUNT",
    "SELLER_CONCESSION_AMOUNT": "SELLER_CONCESSION_AMOUNT",
    "INSPECTION_CONTINGENCY_PERIOD_DURATION": "INSPECTION_CONTINGENCY_PERIOD_DURATION",
    "INSPECTION_CONTINGENCY_PERIOD_COST_AMOUNT": "INSPECTION_CONTINGENCY_PERIOD_COST_AMOUNT",
    "APPRAISAL_CONTINGENCY_DURATION": "APPRAISAL_CONTINGENCY_DURATION",
    "FINANCING_CONTINGENCY_DURATION": "FINANCING_CONTINGENCY_DURATION",
    "AGENT_COMMISSION_PAID_BY": "AGENT_COMMISSION_PAID_BY",
    "AGENT_COMMISSION_AMOUNT": "AGENT_COMMISSION_AMOUNT"
  },
  "SealedBidFieldFeedbackStatus": {
    "UNSEEN": "UNSEEN",
    "ACKNOWLEDGE": "ACKNOWLEDGE"
  },
  "SellerSentiment": {
    "NEUTRAL": "NEUTRAL",
    "NEGATIVE": "NEGATIVE",
    "POSITIVE": "POSITIVE"
  },
  "LiveAuctionSegmentBiddingStatus": {
    "HIGHEST_BID": "HIGHEST_BID",
    "WON": "WON",
    "LOST": "LOST",
    "PLACING_BID": "PLACING_BID",
    "OUTBID": "OUTBID",
    "NO_BID": "NO_BID"
  },
  "OnlineAuctionSegmentBiddingStatus": {
    "HIGHEST_BID": "HIGHEST_BID",
    "WON": "WON",
    "LOST": "LOST",
    "OUTBID": "OUTBID",
    "NO_BID": "NO_BID",
    "WITHDRAWN_BID": "WITHDRAWN_BID",
    "REJECTED_BID": "REJECTED_BID"
  },
  "FundStatus": {
    "APPROVED": "APPROVED",
    "DENIED": "DENIED",
    "PENDING": "PENDING",
    "SUSPENDED": "SUSPENDED"
  },
  "FundTransactionType": {
    "CREDIT": "CREDIT",
    "DEBIT": "DEBIT"
  },
  "OnlineSegmentExtensionType": {
    "MANUAL": "MANUAL",
    "AUTOMATED": "AUTOMATED"
  },
  "OnlineSegmentExtensionReason": {
    "LISTING_CHANGE": "LISTING_CHANGE",
    "BID_AGAIN": "BID_AGAIN",
    "ANTI_BID_SNIPE": "ANTI_BID_SNIPE",
    "HIGH_BIDDER": "HIGH_BIDDER",
    "PENDING_SELLER_CONFIRMATION": "PENDING_SELLER_CONFIRMATION",
    "AUCTIONEER_DISCRETION": "AUCTIONEER_DISCRETION",
    "SELLER_REVIEW_PERIOD_START": "SELLER_REVIEW_PERIOD_START",
    "SELLER_REVIEW_PERIOD_END": "SELLER_REVIEW_PERIOD_END",
    "HIGHEST_AND_BEST_OPEN": "HIGHEST_AND_BEST_OPEN",
    "HIGHEST_AND_BEST_DECISION": "HIGHEST_AND_BEST_DECISION"
  },
  "FundModificationStatus": {
    "ORIGINAL": "ORIGINAL",
    "ALTERED": "ALTERED"
  },
  "LiveAuctionStaffRole": {
    "AUCTION_MANAGER": "AUCTION_MANAGER",
    "AUCTION_SUPPORT": "AUCTION_SUPPORT",
    "AUCTIONEER": "AUCTIONEER",
    "AUDITOR": "AUDITOR",
    "BIDDER_REGISTRATION": "BIDDER_REGISTRATION",
    "BID_TRACKER": "BID_TRACKER",
    "BANKER": "BANKER",
    "CONCIERGE": "CONCIERGE",
    "FLOOR_MANAGER": "FLOOR_MANAGER",
    "RECEIPT_WRITER": "RECEIPT_WRITER",
    "TRAINING": "TRAINING"
  },
  "LiveAuctionStaffAssignmentType": {
    "SCHEDULED": "SCHEDULED",
    "AUTO_ASSIGN": "AUTO_ASSIGN",
    "SELF_ASSIGN": "SELF_ASSIGN"
  },
  "CertificateType": {
    "CANCELED_CERTIFICATE": "CANCELED_CERTIFICATE",
    "POSTPONEMENT_CERTIFICATE": "POSTPONEMENT_CERTIFICATE",
    "CONTRACT_PACKAGE": "CONTRACT_PACKAGE",
    "REVERT_CERTIFICATE": "REVERT_CERTIFICATE",
    "SALE_FAILED_CERTIFICATE": "SALE_FAILED_CERTIFICATE"
  },
  "EMD_REQUIREMENT": {
    "AFTER_SELLER_EXECUTES": "AFTER_SELLER_EXECUTES",
    "AFTER_BUYER_EXECUTES": "AFTER_BUYER_EXECUTES",
    "DATE_BUYER_SIGNS": "DATE_BUYER_SIGNS",
    "AFTER_AUCTION": "AFTER_AUCTION"
  },
  "SellerAssignedSigner": {
    "ADC_POA": "ADC_POA",
    "BACKUP_SIGNER": "BACKUP_SIGNER",
    "CLOSING_COMPANY": "CLOSING_COMPANY",
    "NO_SIGNER_NAME": "NO_SIGNER_NAME",
    "SERVICER_ASSET_MANAGER": "SERVICER_ASSET_MANAGER",
    "SIGNER_NAME": "SIGNER_NAME"
  },
  "AdcAssignedSigner": {
    "BACKUP_SIGNER": "BACKUP_SIGNER",
    "ORIGINAL": "ORIGINAL"
  },
  "SellerConfigurationRecipientRole": {
    "BUYER": "BUYER",
    "CO_BUYER": "CO_BUYER",
    "BUYERS_AGENT": "BUYERS_AGENT",
    "BUYERS_AGENT_BROKER_COMPANY": "BUYERS_AGENT_BROKER_COMPANY",
    "LISTING_AGENT": "LISTING_AGENT",
    "SELLER": "SELLER",
    "SELLER_CLOSING_COMPANY": "SELLER_CLOSING_COMPANY",
    "BUYER_CLOSING_COMPANY": "BUYER_CLOSING_COMPANY"
  },
  "SellerConfigurationRecipientType": {
    "SIGNER": "SIGNER",
    "NOT_REQUIRED": "NOT_REQUIRED",
    "CC": "CC"
  },
  "SellerConfigurationProduct": {
    "SS": "SS",
    "FCL": "FCL",
    "REO": "REO",
    "NON_REO": "NON_REO",
    "CWCOT": "CWCOT"
  },
  "SellerConfigurationProgram": {
    "ALVS": "ALVS",
    "AUCTIONEER": "AUCTIONEER",
    "BANKRUPTCY": "BANKRUPTCY",
    "C2C": "C2C",
    "C6": "C6",
    "CONCIERGE": "CONCIERGE",
    "CWCOT": "CWCOT",
    "CWCOT_REDEMPTION": "CWCOT_REDEMPTION",
    "DAY_1_REO": "DAY_1_REO",
    "DUAL_PATH": "DUAL_PATH",
    "HOC": "HOC",
    "LUXURY": "LUXURY",
    "MIXED": "MIXED",
    "MVP": "MVP",
    "NON_REO": "NON_REO",
    "NVA_OOBA": "NVA_OOBA",
    "OPM": "OPM",
    "PMK": "PMK",
    "PMK_BYOB": "PMK_BYOB",
    "REDEMPTION": "REDEMPTION",
    "RENTAL": "RENTAL",
    "RETAIL": "RETAIL",
    "TRADITIONAL": "TRADITIONAL",
    "TRADITIONAL_BYOB": "TRADITIONAL_BYOB",
    "TRADITIONAL_REO": "TRADITIONAL_REO",
    "USDA": "USDA",
    "UTM": "UTM"
  },
  "SellerConfigurationPortfolio": {
    "HUD": "HUD",
    "HUD_MARKETING_FCL": "HUD_MARKETING_FCL",
    "NON_CLIENT": "NON_CLIENT",
    "NPL": "NPL",
    "PRIVATE": "PRIVATE",
    "USDA": "USDA",
    "VA": "VA"
  },
  "SellerConfigurationDeedType": {
    "WARRANTY_DEED": "WARRANTY_DEED",
    "SPECIAL_WARRANTY_DEED": "SPECIAL_WARRANTY_DEED",
    "QUITCLAIM_DEED": "QUITCLAIM_DEED",
    "QD_ASSIGNMENT_INTEREST": "QD_ASSIGNMENT_INTEREST",
    "QD_ASSIGNMENT_CERT": "QD_ASSIGNMENT_CERT",
    "TRUSTEE_DEED": "TRUSTEE_DEED",
    "RELEASE_DEED": "RELEASE_DEED"
  },
  "SellerConfigurationLineOfBusiness": {
    "PFS": "PFS",
    "FCL": "FCL",
    "REO": "REO"
  },
  "PreAuctionOfferMinimumType": {
    "NOT_SET": "NOT_SET",
    "FINAL_SELLER_RESERVE": "FINAL_SELLER_RESERVE",
    "AUCTION_SELLER_RESERVE": "AUCTION_SELLER_RESERVE",
    "SUBJECT_TO_RESERVE": "SUBJECT_TO_RESERVE",
    "IMPLIED_RESERVE": "IMPLIED_RESERVE"
  },
  "StrategyType": {
    "NOT_SET": "NOT_SET",
    "CURRENCY_AMOUNT": "CURRENCY_AMOUNT",
    "PERCENTAGE": "PERCENTAGE"
  },
  "SellerConfigurationPartyRole": {
    "SELLER": "SELLER",
    "SERVICER": "SERVICER",
    "INVESTOR": "INVESTOR",
    "PARENT_SELLER": "PARENT_SELLER",
    "FORECLOSURE_ATTORNEY": "FORECLOSURE_ATTORNEY",
    "PARENT_COMPANY": "PARENT_COMPANY"
  },
  "SellerConfigurationTitleInsuranceType": {
    "BUYER_TO_PAY": "BUYER_TO_PAY",
    "SELLER_TO_PAY": "SELLER_TO_PAY",
    "NOT_OFFERED": "NOT_OFFERED",
    "REFER_TO_PSA": "REFER_TO_PSA"
  },
  "TrusteeCustomerType": {
    "GUEST": "GUEST",
    "OWNER": "OWNER",
    "REPRESENTATIVE": "REPRESENTATIVE"
  },
  "BidderRegistrationSignupSource": {
    "ADC": "ADC",
    "ANDROID_NATIVE": "ANDROID_NATIVE",
    "AUCTIONSYNC": "AUCTIONSYNC",
    "AUCTIONSYNC_QR": "AUCTIONSYNC_QR",
    "IOS_NATIVE": "IOS_NATIVE",
    "MLH": "MLH",
    "MORPHEUS": "MORPHEUS",
    "TEST": "TEST"
  },
  "BidderVerificationType": {
    "DRIVER_LICENSE": "DRIVER_LICENSE",
    "PASSPORT": "PASSPORT",
    "OTHER": "OTHER"
  },
  "OccupancyType": {
    "OWNER": "OWNER",
    "INVESTOR": "INVESTOR",
    "NON_PROFIT": "NON_PROFIT",
    "SECOND_HOME": "SECOND_HOME",
    "NOT_DISCLOSED": "NOT_DISCLOSED",
    "TO_BE_DETERMINED": "TO_BE_DETERMINED"
  },
  "OnlineRegistrationStatus": {
    "APPROVED": "APPROVED",
    "SUSPENDED": "SUSPENDED",
    "PENDING_DEPOSIT_CONFIRMATION": "PENDING_DEPOSIT_CONFIRMATION"
  },
  "AuctionType": {
    "LIVE": "LIVE",
    "ONLINE": "ONLINE"
  },
  "VerificationStatus": {
    "VERIFICATION_IN_PROGRESS": "VERIFICATION_IN_PROGRESS",
    "APPROVED_VERIFIED": "APPROVED_VERIFIED",
    "NOT_VERIFIED": "NOT_VERIFIED",
    "REJECTED_FRAUD": "REJECTED_FRAUD",
    "REJECTED_DUPLICATE": "REJECTED_DUPLICATE",
    "REJECTED_OTHER": "REJECTED_OTHER",
    "APPROVED_MANUALLY": "APPROVED_MANUALLY",
    "REJECTED_MANUALLY": "REJECTED_MANUALLY"
  },
  "FirstLookBuyerSelectionType": {
    "HOMEBUYER": "HOMEBUYER",
    "ENTITY_APPROVED": "ENTITY_APPROVED",
    "INVESTOR": "INVESTOR"
  },
  "TransactionStatus": {
    "REQUIRES_PAYMENT_METHOD": "REQUIRES_PAYMENT_METHOD",
    "REQUIRES_CONFIRMATION": "REQUIRES_CONFIRMATION",
    "REQUIRES_ACTION": "REQUIRES_ACTION",
    "PROCESSING": "PROCESSING",
    "REQUIRES_CAPTURE": "REQUIRES_CAPTURE",
    "CANCELED": "CANCELED",
    "SUCCEEDED": "SUCCEEDED",
    "PENDING": "PENDING",
    "FAILED": "FAILED",
    "WARNING_NEEDS_RESPONSE": "WARNING_NEEDS_RESPONSE",
    "WARNING_UNDER_REVIEW": "WARNING_UNDER_REVIEW",
    "WARNING_CLOSED": "WARNING_CLOSED",
    "NEEDS_RESPONSE": "NEEDS_RESPONSE",
    "UNDER_REVIEW": "UNDER_REVIEW",
    "WON": "WON",
    "LOST": "LOST"
  },
  "PaymentMethodType": {
    "CARD": "CARD",
    "ACH": "ACH",
    "MANUAL_WIRE_TRANSACTION": "MANUAL_WIRE_TRANSACTION",
    "GENESIS_TRANSACTION": "GENESIS_TRANSACTION"
  },
  "BuyerPaymentType": {
    "ONLINE_BID_DEPOSIT": "ONLINE_BID_DEPOSIT",
    "LIVE_REMOTE_BIDDING": "LIVE_REMOTE_BIDDING"
  },
  "FundReconciliationStatus": {
    "PENDING": "PENDING",
    "SETTLED": "SETTLED"
  },
  "TransactionLogType": {
    "PAYMENT": "PAYMENT",
    "REFUND": "REFUND",
    "CAPTURE": "CAPTURE",
    "CHARGE": "CHARGE",
    "REVERSAL": "REVERSAL",
    "DISPUTE": "DISPUTE"
  },
  "TransactionType": {
    "DEBIT": "DEBIT",
    "PENDING_DEBIT": "PENDING_DEBIT",
    "VOID": "VOID",
    "CREDIT": "CREDIT",
    "PENDING_CREDIT": "PENDING_CREDIT"
  },
  "ChargeReason": {
    "MANUAL_FALLOUT": "MANUAL_FALLOUT",
    "AUTO_FALLOUT": "AUTO_FALLOUT",
    "SALE": "SALE",
    "BANK_CANNOT_PROCESS": "BANK_CANNOT_PROCESS",
    "CHECK_RETURNED": "CHECK_RETURNED",
    "CREDIT_NOT_PROCESSED": "CREDIT_NOT_PROCESSED",
    "CUSTOMER_INITIATED": "CUSTOMER_INITIATED",
    "DEBIT_NOT_AUTHORIZED": "DEBIT_NOT_AUTHORIZED",
    "DUPLICATE": "DUPLICATE",
    "FRAUDULENT": "FRAUDULENT",
    "GENERAL": "GENERAL",
    "INCORRECT_ACCOUNT_DETAILS": "INCORRECT_ACCOUNT_DETAILS",
    "INSUFFICIENT_FUNDS": "INSUFFICIENT_FUNDS",
    "PRODUCT_NOT_RECEIVED": "PRODUCT_NOT_RECEIVED",
    "PRODUCT_UNACCEPTABLE": "PRODUCT_UNACCEPTABLE",
    "SUBSCRIPTION_CANCELED": "SUBSCRIPTION_CANCELED",
    "UNRECOGNIZED": "UNRECOGNIZED"
  },
  "PaymentFailureReason": {
    "AUTHENTICATION_REQUIRED": "AUTHENTICATION_REQUIRED",
    "APPROVE_WITH_ID": "APPROVE_WITH_ID",
    "CALL_ISSUER": "CALL_ISSUER",
    "CARD_NOT_SUPPORTED": "CARD_NOT_SUPPORTED",
    "CARD_VELOCITY_EXCEEDED": "CARD_VELOCITY_EXCEEDED",
    "CURRENCY_NOT_SUPPORTED": "CURRENCY_NOT_SUPPORTED",
    "DO_NOT_HONOR": "DO_NOT_HONOR",
    "DO_NOT_TRY_AGAIN": "DO_NOT_TRY_AGAIN",
    "DUPLICATE_TRANSACTION": "DUPLICATE_TRANSACTION",
    "EXPIRED_CARD": "EXPIRED_CARD",
    "FRAUDULENT": "FRAUDULENT",
    "GENERIC_DECLINE": "GENERIC_DECLINE",
    "INCORRECT_NUMBER": "INCORRECT_NUMBER",
    "INCORRECT_CVC": "INCORRECT_CVC",
    "INCORRECT_PIN": "INCORRECT_PIN",
    "INCORRECT_ZIP": "INCORRECT_ZIP",
    "INSUFFICIENT_FUNDS": "INSUFFICIENT_FUNDS",
    "INVALID_ACCOUNT": "INVALID_ACCOUNT",
    "INVALID_AMOUNT": "INVALID_AMOUNT",
    "INVALID_CVC": "INVALID_CVC",
    "INVALID_EXPIRY_MONTH": "INVALID_EXPIRY_MONTH",
    "INVALID_EXPIRY_YEAR": "INVALID_EXPIRY_YEAR",
    "INVALID_NUMBER": "INVALID_NUMBER",
    "INVALID_PIN": "INVALID_PIN",
    "ISSUER_NOT_AVAILABLE": "ISSUER_NOT_AVAILABLE",
    "LOST_CARD": "LOST_CARD",
    "MERCHANT_BLACKLIST": "MERCHANT_BLACKLIST",
    "NEW_ACCOUNT_INFORMATION_AVAILABLE": "NEW_ACCOUNT_INFORMATION_AVAILABLE",
    "NO_ACTION_TAKEN": "NO_ACTION_TAKEN",
    "NOT_PERMITTED": "NOT_PERMITTED",
    "OFFLINE_PIN_REQUIRED": "OFFLINE_PIN_REQUIRED",
    "ONLINE_OR_OFFLINE_PIN_REQUIRED": "ONLINE_OR_OFFLINE_PIN_REQUIRED",
    "PICKUP_CARD": "PICKUP_CARD",
    "PIN_TRY_EXCEEDED": "PIN_TRY_EXCEEDED",
    "PROCESSING_ERROR": "PROCESSING_ERROR",
    "REENTER_TRANSACTION": "REENTER_TRANSACTION",
    "RESTRICTED_CARD": "RESTRICTED_CARD",
    "REVOCATION_OF_ALL_AUTHORIZATIONS": "REVOCATION_OF_ALL_AUTHORIZATIONS",
    "REVOCATION_OF_AUTHORIZATION": "REVOCATION_OF_AUTHORIZATION",
    "SECURITY_VIOLATION": "SECURITY_VIOLATION",
    "SERVICE_NOT_ALLOWED": "SERVICE_NOT_ALLOWED",
    "STOLEN_CARD": "STOLEN_CARD",
    "STOP_PAYMENT_ORDER": "STOP_PAYMENT_ORDER",
    "TESTMODE_DECLINE": "TESTMODE_DECLINE",
    "TRANSACTION_NOT_ALLOWED": "TRANSACTION_NOT_ALLOWED",
    "TRY_AGAIN_LATER": "TRY_AGAIN_LATER",
    "WITHDRAWAL_COUNT_LIMIT_EXCEEDED": "WITHDRAWAL_COUNT_LIMIT_EXCEEDED",
    "ACCOUNT_CLOSED": "ACCOUNT_CLOSED",
    "ACCOUNT_COUNTRY_INVALID_ADDRESS": "ACCOUNT_COUNTRY_INVALID_ADDRESS",
    "ACCOUNT_ERROR_COUNTRY_CHANGE_REQUIRES_ADDITIONAL_STEPS": "ACCOUNT_ERROR_COUNTRY_CHANGE_REQUIRES_ADDITIONAL_STEPS",
    "ACCOUNT_INFORMATION_MISMATCH": "ACCOUNT_INFORMATION_MISMATCH",
    "ACCOUNT_INVALID": "ACCOUNT_INVALID",
    "ACCOUNT_NUMBER_INVALID": "ACCOUNT_NUMBER_INVALID",
    "ACSS_DEBIT_SESSION_INCOMPLETE": "ACSS_DEBIT_SESSION_INCOMPLETE",
    "ALIPAY_UPGRADE_REQUIRED": "ALIPAY_UPGRADE_REQUIRED",
    "AMOUNT_TOO_LARGE": "AMOUNT_TOO_LARGE",
    "AMOUNT_TOO_SMALL": "AMOUNT_TOO_SMALL",
    "API_KEY_EXPIRED": "API_KEY_EXPIRED",
    "APPLICATION_FEES_NOT_ALLOWED": "APPLICATION_FEES_NOT_ALLOWED",
    "BALANCE_INSUFFICIENT": "BALANCE_INSUFFICIENT",
    "BALANCE_INVALID_PARAMETER": "BALANCE_INVALID_PARAMETER",
    "BANK_ACCOUNT_BAD_ROUTING_NUMBERS": "BANK_ACCOUNT_BAD_ROUTING_NUMBERS",
    "BANK_ACCOUNT_DECLINED": "BANK_ACCOUNT_DECLINED",
    "BANK_ACCOUNT_EXISTS": "BANK_ACCOUNT_EXISTS",
    "BANK_ACCOUNT_RESTRICTED": "BANK_ACCOUNT_RESTRICTED",
    "BANK_ACCOUNT_UNUSABLE": "BANK_ACCOUNT_UNUSABLE",
    "BANK_ACCOUNT_UNVERIFIED": "BANK_ACCOUNT_UNVERIFIED",
    "BANK_ACCOUNT_VERIFICATION_FAILED": "BANK_ACCOUNT_VERIFICATION_FAILED",
    "BILLING_INVALID_MANDATE": "BILLING_INVALID_MANDATE",
    "BITCOIN_UPGRADE_REQUIRED": "BITCOIN_UPGRADE_REQUIRED",
    "CAPTURE_CHARGE_AUTHORIZATION_EXPIRED": "CAPTURE_CHARGE_AUTHORIZATION_EXPIRED",
    "CAPTURE_UNAUTHORIZED_PAYMENT": "CAPTURE_UNAUTHORIZED_PAYMENT",
    "CARD_DECLINE_RATE_LIMIT_EXCEEDED": "CARD_DECLINE_RATE_LIMIT_EXCEEDED",
    "CARD_DECLINED": "CARD_DECLINED",
    "CARDHOLDER_PHONE_NUMBER_REQUIRED": "CARDHOLDER_PHONE_NUMBER_REQUIRED",
    "CHARGE_ALREADY_CAPTURED": "CHARGE_ALREADY_CAPTURED",
    "CHARGE_ALREADY_REFUNDED": "CHARGE_ALREADY_REFUNDED",
    "CHARGE_DISPUTED": "CHARGE_DISPUTED",
    "CHARGE_EXCEEDS_SOURCE_LIMIT": "CHARGE_EXCEEDS_SOURCE_LIMIT",
    "CHARGE_EXCEEDS_TRANSACTION_LIMIT": "CHARGE_EXCEEDS_TRANSACTION_LIMIT",
    "CHARGE_EXPIRED_FOR_CAPTURE": "CHARGE_EXPIRED_FOR_CAPTURE",
    "CHARGE_INVALID_PARAMETER": "CHARGE_INVALID_PARAMETER",
    "CHARGE_NOT_REFUNDABLE": "CHARGE_NOT_REFUNDABLE",
    "CLEARING_CODE_UNSUPPORTED": "CLEARING_CODE_UNSUPPORTED",
    "COUNTRY_CODE_INVALID": "COUNTRY_CODE_INVALID",
    "COUNTRY_UNSUPPORTED": "COUNTRY_UNSUPPORTED",
    "COUPON_EXPIRED": "COUPON_EXPIRED",
    "CUSTOMER_MAX_PAYMENT_METHODS": "CUSTOMER_MAX_PAYMENT_METHODS",
    "CUSTOMER_MAX_SUBSCRIPTIONS": "CUSTOMER_MAX_SUBSCRIPTIONS",
    "CUSTOMER_TAX_LOCATION_INVALID": "CUSTOMER_TAX_LOCATION_INVALID",
    "DEBIT_NOT_AUTHORIZED": "DEBIT_NOT_AUTHORIZED",
    "EMAIL_INVALID": "EMAIL_INVALID",
    "FINANCIAL_CONNECTIONS_ACCOUNT_INACTIVE": "FINANCIAL_CONNECTIONS_ACCOUNT_INACTIVE",
    "FINANCIAL_CONNECTIONS_NO_SUCCESSFUL_TRANSACTION_REFRESH": "FINANCIAL_CONNECTIONS_NO_SUCCESSFUL_TRANSACTION_REFRESH",
    "FORWARDING_API_INACTIVE": "FORWARDING_API_INACTIVE",
    "FORWARDING_API_INVALID_PARAMETER": "FORWARDING_API_INVALID_PARAMETER",
    "FORWARDING_API_UPSTREAM_CONNECTION_ERROR": "FORWARDING_API_UPSTREAM_CONNECTION_ERROR",
    "FORWARDING_API_UPSTREAM_CONNECTION_TIMEOUT": "FORWARDING_API_UPSTREAM_CONNECTION_TIMEOUT",
    "IDEMPOTENCY_KEY_IN_USE": "IDEMPOTENCY_KEY_IN_USE",
    "INCORRECT_ADDRESS": "INCORRECT_ADDRESS",
    "INSTANT_PAYOUTS_CONFIG_DISABLED": "INSTANT_PAYOUTS_CONFIG_DISABLED",
    "INSTANT_PAYOUTS_CURRENCY_DISABLED": "INSTANT_PAYOUTS_CURRENCY_DISABLED",
    "INSTANT_PAYOUTS_LIMIT_EXCEEDED": "INSTANT_PAYOUTS_LIMIT_EXCEEDED",
    "INSTANT_PAYOUTS_UNSUPPORTED": "INSTANT_PAYOUTS_UNSUPPORTED",
    "INTENT_INVALID_STATE": "INTENT_INVALID_STATE",
    "INTENT_VERIFICATION_METHOD_MISSING": "INTENT_VERIFICATION_METHOD_MISSING",
    "INVALID_CARD_TYPE": "INVALID_CARD_TYPE",
    "INVALID_CHARACTERS": "INVALID_CHARACTERS",
    "INVALID_CHARGE_AMOUNT": "INVALID_CHARGE_AMOUNT",
    "INVALID_MANDATE_REFERENCE_PREFIX_FORMAT": "INVALID_MANDATE_REFERENCE_PREFIX_FORMAT",
    "INVALID_SOURCE_USAGE": "INVALID_SOURCE_USAGE",
    "INVALID_TAX_LOCATION": "INVALID_TAX_LOCATION",
    "INVOICE_NO_CUSTOMER_LINE_ITEMS": "INVOICE_NO_CUSTOMER_LINE_ITEMS",
    "INVOICE_NO_PAYMENT_METHOD_TYPES": "INVOICE_NO_PAYMENT_METHOD_TYPES",
    "INVOICE_NO_SUBSCRIPTION_LINE_ITEMS": "INVOICE_NO_SUBSCRIPTION_LINE_ITEMS",
    "INVOICE_NOT_EDITABLE": "INVOICE_NOT_EDITABLE",
    "INVOICE_ON_BEHALF_OF_NOT_EDITABLE": "INVOICE_ON_BEHALF_OF_NOT_EDITABLE",
    "INVOICE_PAYMENT_INTENT_REQUIRES_ACTION": "INVOICE_PAYMENT_INTENT_REQUIRES_ACTION",
    "INVOICE_UPCOMING_NONE": "INVOICE_UPCOMING_NONE",
    "LIVEMODE_MISMATCH": "LIVEMODE_MISMATCH",
    "LOCK_TIMEOUT": "LOCK_TIMEOUT",
    "MISSING": "MISSING",
    "NO_ACCOUNT": "NO_ACCOUNT",
    "NOT_ALLOWED_ON_STANDARD_ACCOUNT": "NOT_ALLOWED_ON_STANDARD_ACCOUNT",
    "OUT_OF_INVENTORY": "OUT_OF_INVENTORY",
    "OWNERSHIP_DECLARATION_NOT_ALLOWED": "OWNERSHIP_DECLARATION_NOT_ALLOWED",
    "PARAMETER_INVALID_EMPTY": "PARAMETER_INVALID_EMPTY",
    "PARAMETER_INVALID_INTEGER": "PARAMETER_INVALID_INTEGER",
    "PARAMETER_INVALID_STRING_BLANK": "PARAMETER_INVALID_STRING_BLANK",
    "PARAMETER_INVALID_STRING_EMPTY": "PARAMETER_INVALID_STRING_EMPTY",
    "PARAMETER_MISSING": "PARAMETER_MISSING",
    "PARAMETER_UNKNOWN": "PARAMETER_UNKNOWN",
    "PARAMETERS_EXCLUSIVE": "PARAMETERS_EXCLUSIVE",
    "PAYMENT_INTENT_ACTION_REQUIRED": "PAYMENT_INTENT_ACTION_REQUIRED",
    "PAYMENT_INTENT_AUTHENTICATION_FAILURE": "PAYMENT_INTENT_AUTHENTICATION_FAILURE",
    "PAYMENT_INTENT_INCOMPATIBLE_PAYMENT_METHOD": "PAYMENT_INTENT_INCOMPATIBLE_PAYMENT_METHOD",
    "PAYMENT_INTENT_INVALID_PARAMETER": "PAYMENT_INTENT_INVALID_PARAMETER",
    "PAYMENT_INTENT_KONBINI_REJECTED_CONFIRMATION_NUMBER": "PAYMENT_INTENT_KONBINI_REJECTED_CONFIRMATION_NUMBER",
    "PAYMENT_INTENT_MANDATE_INVALID": "PAYMENT_INTENT_MANDATE_INVALID",
    "PAYMENT_INTENT_PAYMENT_ATTEMPT_EXPIRED": "PAYMENT_INTENT_PAYMENT_ATTEMPT_EXPIRED",
    "PAYMENT_INTENT_PAYMENT_ATTEMPT_FAILED": "PAYMENT_INTENT_PAYMENT_ATTEMPT_FAILED",
    "PAYMENT_INTENT_UNEXPECTED_STATE": "PAYMENT_INTENT_UNEXPECTED_STATE",
    "PAYMENT_METHOD_BANK_ACCOUNT_ALREADY_VERIFIED": "PAYMENT_METHOD_BANK_ACCOUNT_ALREADY_VERIFIED",
    "PAYMENT_METHOD_BANK_ACCOUNT_BLOCKED": "PAYMENT_METHOD_BANK_ACCOUNT_BLOCKED",
    "PAYMENT_METHOD_BILLING_DETAILS_ADDRESS_MISSING": "PAYMENT_METHOD_BILLING_DETAILS_ADDRESS_MISSING",
    "PAYMENT_METHOD_CONFIGURATION_FAILURES": "PAYMENT_METHOD_CONFIGURATION_FAILURES",
    "PAYMENT_METHOD_CURRENCY_MISMATCH": "PAYMENT_METHOD_CURRENCY_MISMATCH",
    "PAYMENT_METHOD_CUSTOMER_DECLINE": "PAYMENT_METHOD_CUSTOMER_DECLINE",
    "PAYMENT_METHOD_INVALID_PARAMETER": "PAYMENT_METHOD_INVALID_PARAMETER",
    "PAYMENT_METHOD_INVALID_PARAMETER_TESTMODE": "PAYMENT_METHOD_INVALID_PARAMETER_TESTMODE",
    "PAYMENT_METHOD_MICRODEPOSIT_FAILED": "PAYMENT_METHOD_MICRODEPOSIT_FAILED",
    "PAYMENT_METHOD_MICRODEPOSIT_VERIFICATION_AMOUNTS_INVALID": "PAYMENT_METHOD_MICRODEPOSIT_VERIFICATION_AMOUNTS_INVALID",
    "PAYMENT_METHOD_MICRODEPOSIT_VERIFICATION_AMOUNTS_MISMATCH": "PAYMENT_METHOD_MICRODEPOSIT_VERIFICATION_AMOUNTS_MISMATCH",
    "PAYMENT_METHOD_MICRODEPOSIT_VERIFICATION_ATTEMPTS_EXCEEDED": "PAYMENT_METHOD_MICRODEPOSIT_VERIFICATION_ATTEMPTS_EXCEEDED",
    "PAYMENT_METHOD_MICRODEPOSIT_VERIFICATION_DESCRIPTOR_CODE_MISMATCH": "PAYMENT_METHOD_MICRODEPOSIT_VERIFICATION_DESCRIPTOR_CODE_MISMATCH",
    "PAYMENT_METHOD_MICRODEPOSIT_VERIFICATION_TIMEOUT": "PAYMENT_METHOD_MICRODEPOSIT_VERIFICATION_TIMEOUT",
    "PAYMENT_METHOD_NOT_AVAILABLE": "PAYMENT_METHOD_NOT_AVAILABLE",
    "PAYMENT_METHOD_PROVIDER_DECLINE": "PAYMENT_METHOD_PROVIDER_DECLINE",
    "PAYMENT_METHOD_PROVIDER_TIMEOUT": "PAYMENT_METHOD_PROVIDER_TIMEOUT",
    "PAYMENT_METHOD_UNACTIVATED": "PAYMENT_METHOD_UNACTIVATED",
    "PAYMENT_METHOD_UNEXPECTED_STATE": "PAYMENT_METHOD_UNEXPECTED_STATE",
    "PAYMENT_METHOD_UNSUPPORTED_TYPE": "PAYMENT_METHOD_UNSUPPORTED_TYPE",
    "PAYOUT_RECONCILIATION_NOT_READY": "PAYOUT_RECONCILIATION_NOT_READY",
    "PAYOUTS_LIMIT_EXCEEDED": "PAYOUTS_LIMIT_EXCEEDED",
    "PAYOUTS_NOT_ALLOWED": "PAYOUTS_NOT_ALLOWED",
    "PLATFORM_ACCOUNT_REQUIRED": "PLATFORM_ACCOUNT_REQUIRED",
    "PLATFORM_API_KEY_EXPIRED": "PLATFORM_API_KEY_EXPIRED",
    "POSTAL_CODE_INVALID": "POSTAL_CODE_INVALID",
    "PRODUCT_INACTIVE": "PRODUCT_INACTIVE",
    "PROGRESSIVE_ONBOARDING_LIMIT_EXCEEDED": "PROGRESSIVE_ONBOARDING_LIMIT_EXCEEDED",
    "RATE_LIMIT": "RATE_LIMIT",
    "REFER_TO_CUSTOMER": "REFER_TO_CUSTOMER",
    "REFUND_DISPUTED_PAYMENT": "REFUND_DISPUTED_PAYMENT",
    "RESOURCE_ALREADY_EXISTS": "RESOURCE_ALREADY_EXISTS",
    "RESOURCE_MISSING": "RESOURCE_MISSING",
    "RETURN_INTENT_ALREADY_PROCESSED": "RETURN_INTENT_ALREADY_PROCESSED",
    "ROUTING_NUMBER_INVALID": "ROUTING_NUMBER_INVALID",
    "SECRET_KEY_REQUIRED": "SECRET_KEY_REQUIRED",
    "SEPA_UNSUPPORTED_ACCOUNT": "SEPA_UNSUPPORTED_ACCOUNT",
    "SETUP_ATTEMPT_FAILED": "SETUP_ATTEMPT_FAILED",
    "SETUP_INTENT_AUTHENTICATION_FAILURE": "SETUP_INTENT_AUTHENTICATION_FAILURE",
    "SETUP_INTENT_INVALID_PARAMETER": "SETUP_INTENT_INVALID_PARAMETER",
    "SETUP_INTENT_MANDATE_INVALID": "SETUP_INTENT_MANDATE_INVALID",
    "SETUP_INTENT_SETUP_ATTEMPT_EXPIRED": "SETUP_INTENT_SETUP_ATTEMPT_EXPIRED",
    "SETUP_INTENT_UNEXPECTED_STATE": "SETUP_INTENT_UNEXPECTED_STATE",
    "SHIPPING_ADDRESS_INVALID": "SHIPPING_ADDRESS_INVALID",
    "SHIPPING_CALCULATION_FAILED": "SHIPPING_CALCULATION_FAILED",
    "SKU_INACTIVE": "SKU_INACTIVE",
    "STATE_UNSUPPORTED": "STATE_UNSUPPORTED",
    "STATUS_TRANSITION_INVALID": "STATUS_TRANSITION_INVALID",
    "STRIPE_TAX_INACTIVE": "STRIPE_TAX_INACTIVE",
    "TAX_ID_INVALID": "TAX_ID_INVALID",
    "TAXES_CALCULATION_FAILED": "TAXES_CALCULATION_FAILED",
    "TERMINAL_LOCATION_COUNTRY_UNSUPPORTED": "TERMINAL_LOCATION_COUNTRY_UNSUPPORTED",
    "TERMINAL_READER_BUSY": "TERMINAL_READER_BUSY",
    "TERMINAL_READER_HARDWARE_FAULT": "TERMINAL_READER_HARDWARE_FAULT",
    "TERMINAL_READER_INVALID_LOCATION_FOR_PAYMENT": "TERMINAL_READER_INVALID_LOCATION_FOR_PAYMENT",
    "TERMINAL_READER_OFFLINE": "TERMINAL_READER_OFFLINE",
    "TERMINAL_READER_TIMEOUT": "TERMINAL_READER_TIMEOUT",
    "TESTMODE_CHARGES_ONLY": "TESTMODE_CHARGES_ONLY",
    "TLS_VERSION_UNSUPPORTED": "TLS_VERSION_UNSUPPORTED",
    "TOKEN_ALREADY_USED": "TOKEN_ALREADY_USED",
    "TOKEN_CARD_NETWORK_INVALID": "TOKEN_CARD_NETWORK_INVALID",
    "TOKEN_IN_USE": "TOKEN_IN_USE",
    "TRANSFER_SOURCE_BALANCE_PARAMETERS_MISMATCH": "TRANSFER_SOURCE_BALANCE_PARAMETERS_MISMATCH",
    "TRANSFERS_NOT_ALLOWED": "TRANSFERS_NOT_ALLOWED",
    "URL_INVALID": "URL_INVALID"
  },
  "RefundIntentStatus": {
    "PENDING": "PENDING",
    "CREATED": "CREATED"
  },
  "TransactionContextSource": {
    "LISTING": "LISTING",
    "ONLINE_AUCTION_SEGMENT": "ONLINE_AUCTION_SEGMENT",
    "LIVE_AUCTION_SEGMENT": "LIVE_AUCTION_SEGMENT",
    "MANUAL_WIRE_TRANSFER": "MANUAL_WIRE_TRANSFER"
  },
  "TransactionContextAction": {
    "BIDDING_REGISTRATION": "BIDDING_REGISTRATION",
    "FALLOUT": "FALLOUT",
    "SALE": "SALE",
    "CONTRACTING_ADJUSTMENT": "CONTRACTING_ADJUSTMENT",
    "GENERAL_FUNDING": "GENERAL_FUNDING",
    "CREDIT_FOR_CANCELLATION": "CREDIT_FOR_CANCELLATION",
    "ASSIGN_THE_BID_RETURN": "ASSIGN_THE_BID_RETURN",
    "ASSIGN_THE_BID_HOLD": "ASSIGN_THE_BID_HOLD",
    "RETURN_OF_FUNDS": "RETURN_OF_FUNDS",
    "REMAINING_PAYMENT_FOR_CLOSING": "REMAINING_PAYMENT_FOR_CLOSING"
  },
  "TransactionLogReportType": {
    "SUCCESSFUL_PAYMENTS": "SUCCESSFUL_PAYMENTS",
    "IN_PROGRESS_PAYMENTS": "IN_PROGRESS_PAYMENTS",
    "SUCCESSFUL_REFUNDS": "SUCCESSFUL_REFUNDS",
    "IN_PROGRESS_REFUNDS": "IN_PROGRESS_REFUNDS",
    "LIQUIDATED_DAMAGES": "LIQUIDATED_DAMAGES",
    "DISPUTED_LIQUIDATED_DAMAGES": "DISPUTED_LIQUIDATED_DAMAGES",
    "DISPUTED_CARD_PAYMENTS": "DISPUTED_CARD_PAYMENTS",
    "DISPUTED_OTHER_PAYMENTS": "DISPUTED_OTHER_PAYMENTS"
  },
  "OnlineBidDepositRefundBlockReason": {
    "CONTRACT_IN_PROGRESS": "CONTRACT_IN_PROGRESS",
    "RESERVE_MET": "RESERVE_MET",
    "SUBJECT_TO_RESERVE_MET": "SUBJECT_TO_RESERVE_MET",
    "QUALITY_BID": "QUALITY_BID",
    "ACTIVE_BID": "ACTIVE_BID"
  },
  "OnlineBidDepositRefundConsequence": {
    "BID_DELETION": "BID_DELETION",
    "UNREGISTER": "UNREGISTER"
  },
  "SeekQueryType": {
    "EVENTS": "EVENTS",
    "EVENT_TEMPLATES": "EVENT_TEMPLATES",
    "GLOBAL_MEDIA": "GLOBAL_MEDIA",
    "MARKETING_PACKAGES": "MARKETING_PACKAGES",
    "MEDIA_PACKAGES": "MEDIA_PACKAGES",
    "PROPERTIES": "PROPERTIES",
    "VENUES": "VENUES",
    "VENUE_TEMPLATES": "VENUE_TEMPLATES",
    "MLH_SYNC_LOGS": "MLH_SYNC_LOGS",
    "MORPH_LOGS": "MORPH_LOGS",
    "INVITATIONS": "INVITATIONS",
    "LISTINGS": "LISTINGS",
    "ACTIVE_LISTINGS": "ACTIVE_LISTINGS",
    "AUCTIONEER_DASHBOARD_PROJECTIONS": "AUCTIONEER_DASHBOARD_PROJECTIONS",
    "ATTORNEY_DASHBOARD_PROJECTIONS": "ATTORNEY_DASHBOARD_PROJECTIONS"
  },
  "VenueListingCountAggregationCategory": {
    "ACTIVE": "ACTIVE",
    "SCHEDULED": "SCHEDULED"
  },
  "VenueType": {
    "LIVE": "LIVE",
    "ONLINE": "ONLINE",
    "THIRD_PARTY": "THIRD_PARTY"
  },
  "VenueEventType": {
    "NON_TRUSTEE": "NON_TRUSTEE",
    "TRUSTEE": "TRUSTEE"
  },
  "VenueSetting": {
    "BALLROOM": "BALLROOM",
    "COURTHOUSE": "COURTHOUSE",
    "ONLOCATION": "ONLOCATION"
  },
  "VenueClassification": {
    "TRUSTEE_CONVERSION": "TRUSTEE_CONVERSION",
    "TRUSTEE_STANDARD": "TRUSTEE_STANDARD"
  },
  "EventType": {
    "LIVE": "LIVE",
    "ONLINE": "ONLINE",
    "THIRD_PARTY": "THIRD_PARTY"
  },
  "TimeSelection": {
    "EVENT": "EVENT",
    "VENUE": "VENUE"
  },
  "VenueFileType": {
    "GENERAL_ANNOUNCEMENT_RECORDING": "GENERAL_ANNOUNCEMENT_RECORDING"
  },
  "PropertyValuationSource": {
    "MORPHEUS": "MORPHEUS",
    "COLLATERAL_ANALYTICS": "COLLATERAL_ANALYTICS",
    "SERVICER": "SERVICER"
  },
  "PropertyValueDataSource": {
    "MORPHEUS": "MORPHEUS",
    "COLLATERAL_ANALYTICS": "COLLATERAL_ANALYTICS",
    "SERVICER": "SERVICER"
  },
  "PropertyDnaFieldIdentifiers": {
    "APN": "APN",
    "BATHROOMS": "BATHROOMS",
    "BEDROOMS": "BEDROOMS",
    "LOT_SIZE": "LOT_SIZE",
    "SQUARE_FOOTAGE": "SQUARE_FOOTAGE",
    "STRUCTURE_TYPE_CODE": "STRUCTURE_TYPE_CODE",
    "VALUATION": "VALUATION",
    "YEAR_BUILT": "YEAR_BUILT",
    "RENTAL_ESTIMATE": "RENTAL_ESTIMATE"
  },
  "PropertyStructureTypeGroup": {
    "SINGLE_FAMILY": "SINGLE_FAMILY",
    "CONDOS_AND_TOWNHOUSES": "CONDOS_AND_TOWNHOUSES",
    "SINGLE_UNIT": "SINGLE_UNIT",
    "MULTI_FAMILY": "MULTI_FAMILY",
    "LAND": "LAND",
    "OTHER": "OTHER",
    "UNKNOWN": "UNKNOWN"
  },
  "PropertyPhotoTag": {
    "BACKYARD": "BACKYARD",
    "BATHROOM": "BATHROOM",
    "BEDROOM": "BEDROOM",
    "DINING_ROOM": "DINING_ROOM",
    "EXTERIOR_FRONT": "EXTERIOR_FRONT",
    "EXTERIOR": "EXTERIOR",
    "GARAGE": "GARAGE",
    "KITCHEN": "KITCHEN",
    "LIVING_ROOM": "LIVING_ROOM",
    "MASTER_BEDROOM": "MASTER_BEDROOM",
    "POOL": "POOL",
    "STAIRS": "STAIRS"
  },
  "PropertyDocumentUsageType": {
    "CONTRACTING": "CONTRACTING",
    "WEB": "WEB",
    "INTERNAL": "INTERNAL",
    "INACTIVE": "INACTIVE",
    "AUCTIONEER": "AUCTIONEER"
  },
  "PropertyDocumentPurposeType": {
    "AGENT_VISUAL_INSPECTION_DISCLOSURE": "AGENT_VISUAL_INSPECTION_DISCLOSURE",
    "BROKER_PRICE_OPINION": "BROKER_PRICE_OPINION",
    "CODE_VIOLATIONS": "CODE_VIOLATIONS",
    "HOLD_HARMLESS_AGREEMENT": "HOLD_HARMLESS_AGREEMENT",
    "INSPECTION_REPORT": "INSPECTION_REPORT",
    "LEAD_BASED_PAINT_DISCLOSURE": "LEAD_BASED_PAINT_DISCLOSURE",
    "LEASE_AGREEMENT": "LEASE_AGREEMENT",
    "MISCELLANEOUS_DOCUMENT": "MISCELLANEOUS_DOCUMENT",
    "NATURAL_HAZARD_DISCLOSURE": "NATURAL_HAZARD_DISCLOSURE",
    "OTHERS": "OTHERS",
    "PRELIMINARY_TITLE_REPORT": "PRELIMINARY_TITLE_REPORT",
    "PROPERTY_CONDITION_ADDENDUM_AND_RELEASE": "PROPERTY_CONDITION_ADDENDUM_AND_RELEASE",
    "REDACTED_BROKER_PRICE_OPINION": "REDACTED_BROKER_PRICE_OPINION",
    "RENT_LEDGER": "RENT_LEDGER",
    "SPECIAL_DISCLOSURES": "SPECIAL_DISCLOSURES",
    "SELLER_SIGN_DISCLOSURES": "SELLER_SIGN_DISCLOSURES",
    "SPECIAL_ADDENDUMS": "SPECIAL_ADDENDUMS",
    "COVENANTS_CONDITIONS_AND_RESTRICTIONS": "COVENANTS_CONDITIONS_AND_RESTRICTIONS",
    "ADDITIONAL_DISCLOSURE": "ADDITIONAL_DISCLOSURE",
    "LIEN_DISCLOSURE": "LIEN_DISCLOSURE",
    "NOTICE_OF_SALE": "NOTICE_OF_SALE",
    "PLAT_MAP": "PLAT_MAP",
    "PROPERTY_DATA_SHEET": "PROPERTY_DATA_SHEET",
    "LEGAL_DESCRIPTION": "LEGAL_DESCRIPTION",
    "INDEMNIFICATION_AND_HOLD_HARMLESS": "INDEMNIFICATION_AND_HOLD_HARMLESS",
    "PURCHASE_AGREEMENT": "PURCHASE_AGREEMENT",
    "WIRE_INSTRUCTIONS": "WIRE_INSTRUCTIONS",
    "LOCAL_DISCLOSURE": "LOCAL_DISCLOSURE",
    "ACTIVE_LEASE": "ACTIVE_LEASE",
    "CORPORATE_RESOLUTION": "CORPORATE_RESOLUTION"
  },
  "AttorneyCompanyType": {
    "ATTORNEY": "ATTORNEY"
  },
  "DeviceTokenProvider": {
    "APN": "APN",
    "FCM": "FCM"
  },
  "DeviceStatus": {
    "ACTIVE": "ACTIVE",
    "INACTIVE": "INACTIVE"
  },
  "MobileOperatingSystem": {
    "ANDROID": "ANDROID",
    "IOS": "IOS"
  },
  "TrinityCampaignModificationSource": {
    "AUCTIONSYNC": "AUCTIONSYNC"
  },
  "ListingStatusLabelIntent": {
    "SEARCH": "SEARCH",
    "PDP": "PDP"
  },
  "FormattedAddressFormat": {
    "SINGLE_LINE": "SINGLE_LINE",
    "DOUBLE_LINE": "DOUBLE_LINE"
  },
  "GlobalMediaPurpose": {
    "BROKER_PROTECTION_AGREEMENT": "BROKER_PROTECTION_AGREEMENT",
    "DEPOSIT_REQUIREMENT": "DEPOSIT_REQUIREMENT",
    "DISCLOSURE": "DISCLOSURE",
    "HOME_WARRANTY": "HOME_WARRANTY",
    "MISC": "MISC",
    "PURCHASER_INFORMATION_FORM": "PURCHASER_INFORMATION_FORM",
    "PURCHASE_AGREEMENT": "PURCHASE_AGREEMENT",
    "PURCHASE_AGREEMENT_ADDENDUM": "PURCHASE_AGREEMENT_ADDENDUM",
    "SAMPLE_DEED": "SAMPLE_DEED",
    "SAMPLE_THIRD_PARTY_TITLE_REPORT": "SAMPLE_THIRD_PARTY_TITLE_REPORT",
    "SAMPLE_TRUSTEE_CERT_OF_SALE": "SAMPLE_TRUSTEE_CERT_OF_SALE",
    "TAX_FORM": "TAX_FORM",
    "TERMS_AND_CONDITIONS": "TERMS_AND_CONDITIONS"
  },
  "GlobalMediaUsage": {
    "INTERNAL": "INTERNAL",
    "LIVE": "LIVE",
    "MARKETING": "MARKETING",
    "WEB": "WEB",
    "CONTRACTING": "CONTRACTING"
  },
  "GlobalMediaPriorityLevel": {
    "HIGHEST": "HIGHEST",
    "HIGH": "HIGH",
    "MEDIUM": "MEDIUM",
    "LOW": "LOW",
    "LOWEST": "LOWEST"
  },
  "MediaType": {
    "DOCUMENT": "DOCUMENT",
    "IMAGE": "IMAGE"
  },
  "MediaUsageTypeCode": {
    "INTERNAL": "INTERNAL",
    "WEB": "WEB",
    "LIVE": "LIVE",
    "MARKETING": "MARKETING"
  },
  "MediaPurposeType": {
    "BROKER_PRICE_OPINION": "BROKER_PRICE_OPINION",
    "REDACTED_BROKER_PRICE_OPINION": "REDACTED_BROKER_PRICE_OPINION",
    "PRELIMINARY_TITLE_REPORT": "PRELIMINARY_TITLE_REPORT",
    "INSPECTION_REPORT": "INSPECTION_REPORT"
  },
  "ListingGroupType": {
    "VENUE": "VENUE",
    "CAMPAIGN": "CAMPAIGN"
  },
  "PreAuctionStatus": {
    "AUCTION": "AUCTION",
    "CANCELLED": "CANCELLED",
    "POSTPONED": "POSTPONED",
    "REMOVED": "REMOVED",
    "DELETED": "DELETED"
  },
  "AuctionStatus": {
    "PENDING_SCHEDULING": "PENDING_SCHEDULING",
    "SALE_PENDING": "SALE_PENDING",
    "SALE_PENDING_CLEARED": "SALE_PENDING_CLEARED",
    "CLOSED": "CLOSED",
    "NO_SALE": "NO_SALE",
    "SALE_FAILED": "SALE_FAILED",
    "SALE_GATEKEEPING": "SALE_GATEKEEPING",
    "IN_CLOSING": "IN_CLOSING",
    "OUTBID_PERIOD": "OUTBID_PERIOD",
    "POSTPONED": "POSTPONED",
    "CANCELED": "CANCELED",
    "REMOVED": "REMOVED",
    "WITHDRAWN": "WITHDRAWN"
  },
  "ListingStatus": {
    "ELIGIBILITY_PENDING": "ELIGIBILITY_PENDING",
    "PENDING_SCHEDULING": "PENDING_SCHEDULING",
    "POSTPONED_PENDING_SCHEDULING": "POSTPONED_PENDING_SCHEDULING",
    "SALE_PENDING": "SALE_PENDING",
    "SALE_PENDING_CLEARED": "SALE_PENDING_CLEARED",
    "AUCTION_IN_PROGRESS": "AUCTION_IN_PROGRESS",
    "SALE_RESULT_PENDING": "SALE_RESULT_PENDING",
    "SALE_PAYMENT_PENDING": "SALE_PAYMENT_PENDING",
    "CLOSED": "CLOSED",
    "NO_SALE": "NO_SALE",
    "SALE_GATEKEEPING": "SALE_GATEKEEPING",
    "IN_CLOSING": "IN_CLOSING",
    "CANCELED": "CANCELED",
    "POSTPONED": "POSTPONED",
    "REMOVED": "REMOVED",
    "SALE_FAILED": "SALE_FAILED",
    "OUTBID_PERIOD": "OUTBID_PERIOD",
    "IN_STAGING": "IN_STAGING",
    "WITHDRAWN": "WITHDRAWN"
  },
  "ListingStatusGroup": {
    "ACTIVE": "ACTIVE",
    "CANCELED": "CANCELED",
    "SOLD": "SOLD",
    "PENDING": "PENDING",
    "REMOVED": "REMOVED",
    "INACTIVE": "INACTIVE"
  },
  "ProductType": {
    "SHORT_SALE": "SHORT_SALE",
    "REO": "REO",
    "TRUSTEE": "TRUSTEE",
    "REDEMPTION": "REDEMPTION",
    "RENTALS": "RENTALS",
    "PRIVATE_SELLER_INSTITUTIONAL": "PRIVATE_SELLER_INSTITUTIONAL",
    "DAY_1_REO": "DAY_1_REO",
    "FCL_MARKETING": "FCL_MARKETING",
    "PRIVATE_SELLER_INDIVIDUAL": "PRIVATE_SELLER_INDIVIDUAL",
    "PRIVATE_SELLER": "PRIVATE_SELLER"
  },
  "AssetType": {
    "BANK_OWNED": "BANK_OWNED",
    "FORECLOSURE": "FORECLOSURE",
    "SHORT_SALE": "SHORT_SALE",
    "RENTALS": "RENTALS",
    "PRIVATE_SELLER": "PRIVATE_SELLER"
  },
  "ListingProductClassification": {
    "PRE_FORECLOSURE": "PRE_FORECLOSURE",
    "BANK_OWNED": "BANK_OWNED",
    "MARKETING_ONLY": "MARKETING_ONLY",
    "INDIVIDUAL": "INDIVIDUAL",
    "INSTITUTIONAL": "INSTITUTIONAL"
  },
  "IntakeMethodType": {
    "LISTING_PORTAL": "LISTING_PORTAL",
    "SALESFORCE": "SALESFORCE",
    "SALESFORCE_LEADS": "SALESFORCE_LEADS",
    "SYNDICATION": "SYNDICATION"
  },
  "AttributionSourceType": {
    "AUCTION_COM": "AUCTION_COM",
    "SPARK_OFFER": "SPARK_OFFER"
  },
  "OccupancyStatus": {
    "OCCUPIED": "OCCUPIED",
    "UNKNOWN": "UNKNOWN",
    "VACANT": "VACANT"
  },
  "CancelPrimaryReason": {
    "TRUSTEE_DISCRETION": "TRUSTEE_DISCRETION",
    "COURT_ORDER": "COURT_ORDER",
    "BANKRUPTCY": "BANKRUPTCY",
    "BENEFICIARY_REQUEST": "BENEFICIARY_REQUEST",
    "MUTUAL_AGREEMENT": "MUTUAL_AGREEMENT",
    "PENDING_DETAILS": "PENDING_DETAILS",
    "PAYOFF": "PAYOFF",
    "REINSTATEMENT": "REINSTATEMENT",
    "RECEIVED_NEW_DATE": "RECEIVED_NEW_DATE",
    "NATURAL_DISASTER": "NATURAL_DISASTER",
    "LOSS_MITIGATION": "LOSS_MITIGATION",
    "LOAN_MODIFICATION": "LOAN_MODIFICATION",
    "OTHER": "OTHER"
  },
  "PostponementPrimaryReason": {
    "TRUSTEE_DISCRETION": "TRUSTEE_DISCRETION",
    "COURT_ORDER": "COURT_ORDER",
    "BANKRUPTCY": "BANKRUPTCY",
    "BENEFICIARY_REQUEST": "BENEFICIARY_REQUEST",
    "MUTUAL_AGREEMENT": "MUTUAL_AGREEMENT",
    "NATURAL_DISASTER": "NATURAL_DISASTER",
    "OTHER": "OTHER"
  },
  "IntacctTransactionStatus": {
    "SUBMISSION_READY": "SUBMISSION_READY",
    "ASSET_CREATE_SUCCESS": "ASSET_CREATE_SUCCESS",
    "ASSET_CREATE_FAIL": "ASSET_CREATE_FAIL",
    "ASSET_UPDATE_SUCCESS": "ASSET_UPDATE_SUCCESS",
    "ASSET_UPDATE_FAIL": "ASSET_UPDATE_FAIL",
    "INVOICE_CREATE_SUCCESS": "INVOICE_CREATE_SUCCESS",
    "INVOICE_CREATE_FAIL": "INVOICE_CREATE_FAIL"
  },
  "MarketingAvailableStatus": {
    "MARKETING_AVAIL_CLEARED": "MARKETING_AVAIL_CLEARED",
    "MARKETING_AVAIL_NOT_CLEARED": "MARKETING_AVAIL_NOT_CLEARED"
  },
  "SellerType": {
    "INSTITUTIONAL": "INSTITUTIONAL",
    "NON_INSTITUTIONAL": "NON_INSTITUTIONAL"
  },
  "CriedBy": {
    "AUCTIONEERING": "AUCTIONEERING",
    "CONCIERGE": "CONCIERGE"
  },
  "BuyerPath": {
    "PROXY_BID": "PROXY_BID",
    "MAKE_AN_OFFER": "MAKE_AN_OFFER"
  },
  "RemarkPurpose": {
    "COMMENT_FROM_TRUSTEE_ATTORNEY": "COMMENT_FROM_TRUSTEE_ATTORNEY"
  },
  "BidType": {
    "SPECIFIED": "SPECIFIED",
    "HIGH_LOW": "HIGH_LOW",
    "TOTAL_DEBT": "TOTAL_DEBT",
    "REDEMPTION": "REDEMPTION"
  },
  "BidSource": {
    "TRUSTEE": "TRUSTEE",
    "SERVICER": "SERVICER",
    "WEB_SERVICE": "WEB_SERVICE"
  },
  "ExternalSyncStatus": {
    "PENDING": "PENDING",
    "SUCCESS": "SUCCESS"
  },
  "PropertyCondition": {
    "WELL_MAINTAINED": "WELL_MAINTAINED",
    "DATED": "DATED",
    "FIXER_UPPER": "FIXER_UPPER",
    "OTHER": "OTHER"
  },
  "ListingPaidBy": {
    "SELLER": "SELLER",
    "BUYER": "BUYER",
    "ADC": "ADC"
  },
  "ListingLandOwnershipType": {
    "FEE_SIMPLE": "FEE_SIMPLE",
    "LEASEHOLD": "LEASEHOLD"
  },
  "ListingDeedType": {
    "WARRANTY_DEED": "WARRANTY_DEED",
    "SPECIAL_WARRANTY_DEED": "SPECIAL_WARRANTY_DEED",
    "QUITCLAIM_DEED": "QUITCLAIM_DEED",
    "QD_ASSIGNMENT_INTEREST": "QD_ASSIGNMENT_INTEREST",
    "QD_ASSIGNMENT_CERT": "QD_ASSIGNMENT_CERT",
    "TRUSTEE_DEED": "TRUSTEE_DEED",
    "RELEASE_DEED": "RELEASE_DEED"
  },
  "CommissionStrategyType": {
    "NOT_SET": "NOT_SET",
    "DOLLAR": "DOLLAR",
    "PERCENTAGE": "PERCENTAGE",
    "INVALID": "INVALID"
  },
  "SellerProductTypes": {
    "SHORT_SALE": "SHORT_SALE",
    "FORECLOSURE": "FORECLOSURE",
    "REO": "REO",
    "NON_REO": "NON_REO",
    "CWCOT": "CWCOT"
  },
  "MarketingAttributeType": {
    "AUCTIONEER_DIALOGUE_CLEARANCE": "AUCTIONEER_DIALOGUE_CLEARANCE",
    "AUCTIONEER_DIALOGUE_POSTPONEMENT": "AUCTIONEER_DIALOGUE_POSTPONEMENT",
    "AUCTIONEER_LICENSING": "AUCTIONEER_LICENSING",
    "CONTACT": "CONTACT",
    "CUSTOMER_SERVICE_NUMBER": "CUSTOMER_SERVICE_NUMBER",
    "DEPOSIT_CHECK_VERBIAGE": "DEPOSIT_CHECK_VERBIAGE",
    "COS_DISCLAIMER": "COS_DISCLAIMER",
    "DISCLAIMER": "DISCLAIMER",
    "FINAL_JUDGEMENT_AMOUNT": "FINAL_JUDGEMENT_AMOUNT",
    "GENERAL_ANNOUNCEMENT": "GENERAL_ANNOUNCEMENT",
    "NOS_AMOUNT": "NOS_AMOUNT",
    "OPENING_BID": "OPENING_BID",
    "TRANSACTION_DETAILS": "TRANSACTION_DETAILS",
    "ORIGINAL_PRINCIPAL_BALANCE": "ORIGINAL_PRINCIPAL_BALANCE",
    "RESERVE_AMOUNT": "RESERVE_AMOUNT",
    "SALES_AGENT_CONTACT": "SALES_AGENT_CONTACT",
    "TRUSTEE_SALE_NUMBER": "TRUSTEE_SALE_NUMBER",
    "REMOTE_BID": "REMOTE_BID",
    "REMOTE_BID_BEFORE_AND_DURING_AUCTION": "REMOTE_BID_BEFORE_AND_DURING_AUCTION",
    "AUCTIONSYNC_ASSET_MANAGEMENT": "AUCTIONSYNC_ASSET_MANAGEMENT",
    "FCL_BUYER_COS_EMAIL": "FCL_BUYER_COS_EMAIL",
    "FCL_TRUSTEE_EMAIL": "FCL_TRUSTEE_EMAIL",
    "DEPOSIT": "DEPOSIT",
    "SECOND_PAYMENT_VERBIAGE": "SECOND_PAYMENT_VERBIAGE",
    "SELLER_DISCLOSURE": "SELLER_DISCLOSURE",
    "FIRST_LOOK_SPECIAL": "FIRST_LOOK_SPECIAL",
    "STATE_DEPOSIT_BALANCE_DUE_VERBIAGE": "STATE_DEPOSIT_BALANCE_DUE_VERBIAGE"
  },
  "ListingPartyRole": {
    "ASSET_MANAGER": "ASSET_MANAGER",
    "SELLER_ASSET_MANAGER": "SELLER_ASSET_MANAGER",
    "OUTSOURCER": "OUTSOURCER",
    "OUTSOURCER_CONTACT": "OUTSOURCER_CONTACT",
    "BROKER": "BROKER",
    "BROKER_CONTACT": "BROKER_CONTACT",
    "BROKER_AGENT": "BROKER_AGENT",
    "BROKER_AGENT_CONTACT": "BROKER_AGENT_CONTACT",
    "FORECLOSURE_ATTORNEY": "FORECLOSURE_ATTORNEY",
    "FORECLOSURE_ATTORNEY_CONTACT": "FORECLOSURE_ATTORNEY_CONTACT",
    "SELLER_CLOSING_COMPANY": "SELLER_CLOSING_COMPANY",
    "SELLER_CLOSING_COMPANY_CONTACT": "SELLER_CLOSING_COMPANY_CONTACT",
    "AUCTION_CLOSING_COMPANY": "AUCTION_CLOSING_COMPANY",
    "AUCTION_CLOSING_COMPANY_CONTACT": "AUCTION_CLOSING_COMPANY_CONTACT",
    "ESCROW_OFFICE": "ESCROW_OFFICE",
    "ESCROW_OFFICE_CONTACT": "ESCROW_OFFICE_CONTACT",
    "ESCROW_OFFICER": "ESCROW_OFFICER",
    "ESCROW_OFFICER_CONTACT": "ESCROW_OFFICER_CONTACT",
    "SERVICER": "SERVICER",
    "SERVICER_CONTACT": "SERVICER_CONTACT",
    "SERVICER_ASSET_MANAGER_CONTACT": "SERVICER_ASSET_MANAGER_CONTACT",
    "INVESTOR": "INVESTOR",
    "CONTRACT_CLOSING_COMPANY": "CONTRACT_CLOSING_COMPANY",
    "CONTRACT_CLOSING_COMPANY_CONTACT": "CONTRACT_CLOSING_COMPANY_CONTACT",
    "WIRE_INSTRUCTION_COMPANY": "WIRE_INSTRUCTION_COMPANY",
    "WIRE_INSTRUCTION_COMPANY_CONTACT": "WIRE_INSTRUCTION_COMPANY_CONTACT",
    "BENEFICIARY": "BENEFICIARY",
    "BENEFICIARY_CONTACT": "BENEFICIARY_CONTACT",
    "ORIGINAL_BENEFICIARY": "ORIGINAL_BENEFICIARY",
    "TRUSTOR": "TRUSTOR",
    "TRUSTOR_CONTACT": "TRUSTOR_CONTACT",
    "SELLER_VESTING": "SELLER_VESTING",
    "SELLER_VESTING_CONTACT": "SELLER_VESTING_CONTACT",
    "LISTING_AGENT": "LISTING_AGENT",
    "LISTING_AGENT_CONTACT": "LISTING_AGENT_CONTACT",
    "MORTGAGE_INSURANCE_COMPANY": "MORTGAGE_INSURANCE_COMPANY",
    "TITLE_UNDERWRITER": "TITLE_UNDERWRITER",
    "TITLE_COMPANY": "TITLE_COMPANY",
    "TITLE_COMPANY_CONTACT": "TITLE_COMPANY_CONTACT",
    "PRIVATE_SELLER": "PRIVATE_SELLER"
  },
  "ScheduleStatus": {
    "PENDING_SCHEDULING": "PENDING_SCHEDULING",
    "FAILED": "FAILED",
    "SCHEDULED": "SCHEDULED"
  },
  "ScheduleFailureReason": {
    "MANY_MATCH": "MANY_MATCH",
    "NO_MATCH": "NO_MATCH",
    "MISSING_CRITERIA": "MISSING_CRITERIA",
    "INTERNAL_ERROR": "INTERNAL_ERROR",
    "REQUIRES_NEW_VENUE": "REQUIRES_NEW_VENUE",
    "REQUIRES_NEW_SCHEDULE": "REQUIRES_NEW_SCHEDULE"
  },
  "MarketingAttributeClass": {
    "CONTENT": "CONTENT",
    "FEATURE_TOGGLE": "FEATURE_TOGGLE"
  },
  "ClosingCancellationReason": {
    "BUYER_NON_PERFORMANCE": "BUYER_NON_PERFORMANCE",
    "BUYER_REMORSE": "BUYER_REMORSE",
    "BUYER_REMORSE_TERMS_OF_LEASE": "BUYER_REMORSE_TERMS_OF_LEASE",
    "BUYER_TERMINATION": "BUYER_TERMINATION",
    "CITY_INSPECTION_FAILED": "CITY_INSPECTION_FAILED",
    "CLOSER_ESCROW_DELAY": "CLOSER_ESCROW_DELAY",
    "DELAY_OF_ESCROW": "DELAY_OF_ESCROW",
    "EMD_NOT_DEPOSITED": "EMD_NOT_DEPOSITED",
    "ESCROW_CO_DELAY": "ESCROW_CO_DELAY",
    "FALLOUT_MLH": "FALLOUT_MLH",
    "FALLOUT_MORPHEUS": "FALLOUT_MORPHEUS",
    "FINANCING_FAILED": "FINANCING_FAILED",
    "FUNDS_TO_CLOSE": "FUNDS_TO_CLOSE",
    "NATURAL_DISASTER": "NATURAL_DISASTER",
    "NEGOTIATOR_DELAY_APPROVAL_LETTER": "NEGOTIATOR_DELAY_APPROVAL_LETTER",
    "ONLINE_CONTRACT_NOT_FINALIZED": "ONLINE_CONTRACT_NOT_FINALIZED",
    "PROPERTY_ISSUES": "PROPERTY_ISSUES",
    "RENTALS_BUYER_FINANCING_FAILED": "RENTALS_BUYER_FINANCING_FAILED",
    "RENTALS_LEASE_AGREEMENT_NOT_ASSIGNABLE": "RENTALS_LEASE_AGREEMENT_NOT_ASSIGNABLE",
    "RENTALS_LENDER_APPRAISAL_ISSUE": "RENTALS_LENDER_APPRAISAL_ISSUE",
    "RENTALS_TENANT_UNCOOPERATIVE": "RENTALS_TENANT_UNCOOPERATIVE",
    "SELLER_DELAY_EXECUTION_OF_DOCUMENTS": "SELLER_DELAY_EXECUTION_OF_DOCUMENTS",
    "SELLER_DELAY_FORECLOSURE_DEED_NOT_RECORDED": "SELLER_DELAY_FORECLOSURE_DEED_NOT_RECORDED",
    "SELLER_DELAY_NO_RESPONSE_TO_SUBJECT_TO": "SELLER_DELAY_NO_RESPONSE_TO_SUBJECT_TO",
    "SELLER_DELAY_UNABLE_TO_PERFORM": "SELLER_DELAY_UNABLE_TO_PERFORM",
    "SELLER_REJECTED": "SELLER_REJECTED",
    "SELLER_TERMINATION": "SELLER_TERMINATION",
    "SERVICER_DELAY_APPROVAL_SHORT_SALE_OFFER": "SERVICER_DELAY_APPROVAL_SHORT_SALE_OFFER",
    "SERVICER_TERMINATION_NON_ARMS_LENGTH": "SERVICER_TERMINATION_NON_ARMS_LENGTH",
    "SHORT_SALE_ISSUE": "SHORT_SALE_ISSUE",
    "SHORT_SALE_OFFER_REJECTED_BORROWER": "SHORT_SALE_OFFER_REJECTED_BORROWER",
    "SHORT_SALE_OFFER_REJECTED_MI_COMPANY": "SHORT_SALE_OFFER_REJECTED_MI_COMPANY",
    "SHORT_SALE_OFFER_REJECTED_SERVICER": "SHORT_SALE_OFFER_REJECTED_SERVICER",
    "TITLE_COMPANY_PERFORMANCE": "TITLE_COMPANY_PERFORMANCE",
    "TITLE_ISSUES": "TITLE_ISSUES",
    "UNCOOPERATIVE_OCCUPANT": "UNCOOPERATIVE_OCCUPANT",
    "INVALID": "INVALID"
  },
  "UserListingAuthorizationAction": {
    "ONLINE_BIDDING_REGISTRATION": "ONLINE_BIDDING_REGISTRATION",
    "ONLINE_REGULAR_BIDDING": "ONLINE_REGULAR_BIDDING",
    "ONLINE_PROXY_BIDDING": "ONLINE_PROXY_BIDDING",
    "ONLINE_DIRECT_OFFER": "ONLINE_DIRECT_OFFER"
  },
  "ListingClosingResponsibilityType": {
    "AUCTION_STANDARD": "AUCTION_STANDARD",
    "AUCTION_TRANSACTION_DETAILS": "AUCTION_TRANSACTION_DETAILS",
    "NONE": "NONE"
  },
  "ListingFinanceType": {
    "FHA": "FHA",
    "CONVENTIONAL": "CONVENTIONAL",
    "FHA203K": "FHA203K",
    "CASH": "CASH",
    "VA": "VA",
    "LINE_OF_CREDIT": "LINE_OF_CREDIT",
    "HARD_MONEY_LOAN": "HARD_MONEY_LOAN",
    "FHA_203B": "FHA_203B",
    "FHA_203K": "FHA_203K",
    "FHA_203B_REPAIR_ESCROW": "FHA_203B_REPAIR_ESCROW",
    "OTHER": "OTHER"
  },
  "FinanceType": {
    "CASH": "CASH",
    "HARD_MONEY_LOAN": "HARD_MONEY_LOAN",
    "REHAB_LOAN": "REHAB_LOAN",
    "LINE_OF_CREDIT": "LINE_OF_CREDIT",
    "CONVENTIONAL": "CONVENTIONAL",
    "CHECK": "CHECK",
    "WIRE": "WIRE",
    "VA": "VA",
    "USDA": "USDA",
    "FHA": "FHA",
    "FHA_203K": "FHA_203K",
    "IRC_1031_EXCHANGE": "IRC_1031_EXCHANGE",
    "FHA_203B": "FHA_203B",
    "FHA_203B_REPAIR_ESCROW": "FHA_203B_REPAIR_ESCROW",
    "HELOC": "HELOC",
    "OTHER": "OTHER"
  },
  "ListingTermsEnforcement": {
    "MANDATORY": "MANDATORY",
    "NEGOTIABLE": "NEGOTIABLE"
  },
  "ListingMoveOutPreference": {
    "MOVE_OUT_AT_CLOSING": "MOVE_OUT_AT_CLOSING",
    "MOVE_OUT_AT_SPECIFIED_DATE": "MOVE_OUT_AT_SPECIFIED_DATE",
    "LEASEBACK": "LEASEBACK",
    "UNKNOWN": "UNKNOWN"
  },
  "ListingExternalIdentifierDataSource": {
    "TRINITY": "TRINITY",
    "TRINITY_PID": "TRINITY_PID",
    "SFDC_ASSET_ID": "SFDC_ASSET_ID",
    "SYNDICATION_PROPERTY_ID": "SYNDICATION_PROPERTY_ID",
    "SYNDICATION_PROPERTY_URL": "SYNDICATION_PROPERTY_URL",
    "GLOBAL_PROPERTY_ID": "GLOBAL_PROPERTY_ID",
    "RCP_PROPERTY_ID": "RCP_PROPERTY_ID",
    "MLH_PROPERTY_ID": "MLH_PROPERTY_ID",
    "MLH": "MLH"
  },
  "CertificateQualityControlStatus": {
    "NO_REVIEW": "NO_REVIEW",
    "APPROVED": "APPROVED",
    "DISAPPROVED": "DISAPPROVED"
  },
  "ListingTitleInsurancePolicy": {
    "BUYER_TO_PAY": "BUYER_TO_PAY",
    "SELLER_TO_PAY": "SELLER_TO_PAY",
    "NOT_OFFERED": "NOT_OFFERED",
    "REFER_TO_PSA": "REFER_TO_PSA"
  },
  "ListingStrategySellingMethodType": {
    "ONLINE_AUCTION_SEGMENT": "ONLINE_AUCTION_SEGMENT",
    "LIVE_AUCTION_SEGMENT": "LIVE_AUCTION_SEGMENT",
    "DIRECT_OFFER_AUCTION": "DIRECT_OFFER_AUCTION"
  },
  "ListingStrategyClosingMethodType": {
    "REO_OFFER": "REO_OFFER",
    "TRUSTEE_CONTRACT": "TRUSTEE_CONTRACT"
  },
  "ListingStrategyPricingStrategy": {
    "BANDED_BY_RESERVE": "BANDED_BY_RESERVE"
  },
  "ListingStrategyBidDepositStrategy": {
    "NOT_REQUIRED": "NOT_REQUIRED",
    "ADC_STANDARD_AMOUNT": "ADC_STANDARD_AMOUNT"
  },
  "LawCode": {
    "AB2424": "AB2424",
    "SB1079": "SB1079"
  },
  "LegalConstraintCode": {
    "REAUCTION_IF_RESERVE_LESS_THAN_STARTING_BID": "REAUCTION_IF_RESERVE_LESS_THAN_STARTING_BID"
  },
  "LeadIntakeProgramType": {
    "PRE_FORECLOSURE": "PRE_FORECLOSURE",
    "SELL_WITH_US": "SELL_WITH_US"
  },
  "RelationshipToProperty": {
    "OWNER": "OWNER",
    "PART_OWNER": "PART_OWNER",
    "REPRESENTATIVE_OF_OWNER": "REPRESENTATIVE_OF_OWNER",
    "OWNER_WITH_AGENT": "OWNER_WITH_AGENT"
  },
  "LeadIntakeSyncStatus": {
    "FAILED": "FAILED",
    "PENDING": "PENDING",
    "SUCCESS": "SUCCESS"
  },
  "OccupancyDescriptionType": {
    "VACANT": "VACANT",
    "OWNER_OCCUPIED": "OWNER_OCCUPIED",
    "TENANT_OCCUPIED": "TENANT_OCCUPIED",
    "ADVERSELY_OCCUPIED": "ADVERSELY_OCCUPIED"
  },
  "SellerIntentType": {
    "SPEED": "SPEED",
    "VALUE": "VALUE",
    "FLEXIBILITY": "FLEXIBILITY"
  },
  "ConsumerListingStatus": {
    "AGENT_REVIEW_REQUESTED": "AGENT_REVIEW_REQUESTED",
    "AGENT_REVIEW_STARTED": "AGENT_REVIEW_STARTED",
    "AGENT_REVIEW_SUBMITTED": "AGENT_REVIEW_SUBMITTED",
    "REVIEW": "REVIEW",
    "REVIEW_COMPLETE": "REVIEW_COMPLETE",
    "UNKNOWN": "UNKNOWN"
  },
  "ConsumerListingLienType": {
    "HUD_DAY_ONE": "HUD_DAY_ONE",
    "HOA_DEMAND": "HOA_DEMAND",
    "OTHER": "OTHER",
    "POINT_OF_SALE_INSPECTION": "POINT_OF_SALE_INSPECTION",
    "PRORATED_TAX": "PRORATED_TAX",
    "TAX": "TAX",
    "UTILITIES": "UTILITIES"
  },
  "ConsumerListingMoveOutPreference": {
    "MOVE_OUT_AT_CLOSING": "MOVE_OUT_AT_CLOSING",
    "MOVE_OUT_AT_SPECIFIED_DATE": "MOVE_OUT_AT_SPECIFIED_DATE",
    "LEASE_BACK": "LEASE_BACK",
    "INVALID": "INVALID"
  },
  "ConsumerListingPartyRole": {
    "BROKER": "BROKER",
    "LISTING_AGENT": "LISTING_AGENT",
    "BROKER_AGENT": "BROKER_AGENT",
    "SELLER_VESTING": "SELLER_VESTING",
    "SELLER_CLOSING_COMPANY": "SELLER_CLOSING_COMPANY",
    "SELLER_CLOSING_COMPANY_CONTACT": "SELLER_CLOSING_COMPANY_CONTACT",
    "AUTHORIZED_THIRD_PARTY": "AUTHORIZED_THIRD_PARTY"
  },
  "ConsumerListingDocumentPurposeType": {
    "AGENT_VALUATION": "AGENT_VALUATION",
    "CLOSING_ADDENDUM": "CLOSING_ADDENDUM",
    "INVALID": "INVALID",
    "LIEN_DOCUMENT": "LIEN_DOCUMENT",
    "LISTING_AGREEMENT": "LISTING_AGREEMENT",
    "MLS_SHEET": "MLS_SHEET",
    "OTHERS": "OTHERS",
    "PROPERTY_DISCLOSURES": "PROPERTY_DISCLOSURES",
    "TITLE_LIEN_REPORT": "TITLE_LIEN_REPORT",
    "WIRE_INSTRUCTIONS": "WIRE_INSTRUCTIONS"
  },
  "ConsumerListingCompletionStatus": {
    "NOT_STARTED": "NOT_STARTED",
    "LISTING_DETAILS": "LISTING_DETAILS",
    "PROPERTY_PHOTOS": "PROPERTY_PHOTOS",
    "PROPERTY_VALUATIONS": "PROPERTY_VALUATIONS",
    "TITLE_INFORMATION": "TITLE_INFORMATION",
    "CLOSING_INFORMATION": "CLOSING_INFORMATION",
    "COMPLETED": "COMPLETED",
    "UNKNOWN": "UNKNOWN"
  },
  "MlhSyncStatus": {
    "SUCCESS": "SUCCESS",
    "ERROR": "ERROR",
    "INFO": "INFO"
  },
  "DirectOfferEventAction": {
    "CREATED": "CREATED",
    "ACCEPTED": "ACCEPTED",
    "DECLINED": "DECLINED",
    "AUTO_DECLINE": "AUTO_DECLINE",
    "AUTO_WITHDRAW": "AUTO_WITHDRAW",
    "WITHDRAWN": "WITHDRAWN",
    "EXPIRED": "EXPIRED",
    "REVIEWED": "REVIEWED",
    "FALLOUT": "FALLOUT",
    "COUNTERED": "COUNTERED"
  },
  "DirectOfferType": {
    "INITIAL": "INITIAL",
    "COUNTER": "COUNTER"
  },
  "DirectOfferStatus": {
    "PENDING": "PENDING",
    "ACCEPTED": "ACCEPTED",
    "DECLINED": "DECLINED",
    "AUTO_DECLINE": "AUTO_DECLINE",
    "EXPIRED": "EXPIRED",
    "WITHDRAWN": "WITHDRAWN",
    "AUTO_WITHDRAW": "AUTO_WITHDRAW",
    "FALLOUT": "FALLOUT",
    "COUNTERED": "COUNTERED"
  },
  "DirectOfferUserType": {
    "SELLER": "SELLER",
    "BUYER": "BUYER",
    "SYSTEM": "SYSTEM"
  },
  "DirectOfferCategory": {
    "ACTIVE": "ACTIVE",
    "INACTIVE": "INACTIVE",
    "WON": "WON"
  },
  "DirectOfferActivityType": {
    "SUBMITTED": "SUBMITTED",
    "FALLOUT": "FALLOUT",
    "REVIEWED": "REVIEWED",
    "ACCEPTED": "ACCEPTED",
    "DECLINED": "DECLINED",
    "AUTO_DECLINE": "AUTO_DECLINE",
    "COUNTERED": "COUNTERED",
    "WITHDRAWN": "WITHDRAWN",
    "AUTO_WITHDRAW": "AUTO_WITHDRAW",
    "EXPIRED": "EXPIRED"
  },
  "DirectOfferBuyerAction": {
    "ACCEPT": "ACCEPT",
    "COUNTER": "COUNTER",
    "DECLINE": "DECLINE",
    "WITHDRAW": "WITHDRAW"
  },
  "NotificationCategoryCode": {
    "CONTRACTING": "CONTRACTING",
    "CLOSING": "CLOSING",
    "BIDDING": "BIDDING",
    "ACCOUNT_SETUP": "ACCOUNT_SETUP",
    "MARKETING": "MARKETING"
  },
  "NotificationIntentCode": {
    "ACTION_NEEDED": "ACTION_NEEDED",
    "ACTION_REQUESTED": "ACTION_REQUESTED",
    "OUTCOME_POSITIVE": "OUTCOME_POSITIVE",
    "OUTCOME_NEGATIVE": "OUTCOME_NEGATIVE"
  },
  "NotificationChannelType": {
    "SMS": "SMS",
    "WEB": "WEB",
    "EMAIL": "EMAIL",
    "TWILIO_STUDIO": "TWILIO_STUDIO",
    "EXTERNAL": "EXTERNAL"
  },
  "CommunicationMethod": {
    "PHONE_CALL": "PHONE_CALL",
    "PHONE_TEXT": "PHONE_TEXT",
    "EMAIL": "EMAIL"
  },
  "SalesforceSubscriptionGroup": {
    "NEWSLETTERS": "NEWSLETTERS",
    "EVENTS": "EVENTS",
    "PROPERTY_RECOMMENDATIONS": "PROPERTY_RECOMMENDATIONS",
    "LIVE_AUCTION_UPDATES": "LIVE_AUCTION_UPDATES"
  },
  "DocumentExternalIdentifierType": {
    "REO_OFFER_CONTRACT": "REO_OFFER_CONTRACT",
    "REO_OFFER_EXTENSION": "REO_OFFER_EXTENSION",
    "REO_OFFER_CANCELLATION": "REO_OFFER_CANCELLATION"
  },
  "LeadAuctionType": {
    "AUCTIONEERING": "AUCTIONEERING",
    "CONCIERGE": "CONCIERGE"
  },
  "AttorneyLeadStatus": {
    "CANCELLED": "CANCELLED",
    "SOLD_TO_THIRD_PARTY": "SOLD_TO_THIRD_PARTY",
    "REVERT_TO_BENEFICIARY": "REVERT_TO_BENEFICIARY",
    "PENDING_AUCTION": "PENDING_AUCTION",
    "POSTPONED": "POSTPONED",
    "RETURNED": "RETURNED",
    "CLEARED_FOR_SALES": "CLEARED_FOR_SALES",
    "PENDING_RESULT": "PENDING_RESULT",
    "AUCTION_IN_PROGRESS": "AUCTION_IN_PROGRESS",
    "INELIGIBLE": "INELIGIBLE",
    "UNSCHEDULED": "UNSCHEDULED",
    "SALE_FAILED": "SALE_FAILED"
  },
  "LeadExceptionType": {
    "PENDING_INVESTOR": "PENDING_INVESTOR",
    "PENDING_LOAN_TYPE": "PENDING_LOAN_TYPE",
    "PENDING_SALE_TIME": "PENDING_SALE_TIME",
    "PENDING_ATTORNEY_CREDIT_BID": "PENDING_ATTORNEY_CREDIT_BID",
    "LESS_THAN_FIFTEEN_MARKETING_DAYS": "LESS_THAN_FIFTEEN_MARKETING_DAYS",
    "PENDING_ATTORNEY_REFERRAL": "PENDING_ATTORNEY_REFERRAL",
    "PENDING_SERVICER_REFERRAL": "PENDING_SERVICER_REFERRAL",
    "PENDING_SERVICER_BID": "PENDING_SERVICER_BID",
    "PENDING_TOTAL_DEBT": "PENDING_TOTAL_DEBT"
  },
  "ObjectChangeReviewStatus": {
    "PENDING": "PENDING",
    "ACCEPTED": "ACCEPTED",
    "REJECTED": "REJECTED",
    "CANCELED": "CANCELED",
    "FAILED": "FAILED"
  },
  "ExternallySubmittedSalesResultType": {
    "SOLD": "SOLD",
    "REVERTED": "REVERTED"
  },
  "UserDocumentPurpose": {
    "PROOF_OF_FUNDS": "PROOF_OF_FUNDS",
    "BUYERS_AGENT_AGREEMENT": "BUYERS_AGENT_AGREEMENT"
  },
  "FinanceTransactionStatus": {
    "ASSET_CREATE_FAIL": "ASSET_CREATE_FAIL",
    "ASSET_CREATE_SUCCESS": "ASSET_CREATE_SUCCESS",
    "ASSET_UPDATE_FAIL": "ASSET_UPDATE_FAIL",
    "ASSET_UPDATE_SUCCESS": "ASSET_UPDATE_SUCCESS",
    "CUSTOMER_CREATE_FAIL": "CUSTOMER_CREATE_FAIL",
    "CUSTOMER_UPDATE_FAIL": "CUSTOMER_UPDATE_FAIL",
    "CUSTOMER_UPDATE_SUCCESS": "CUSTOMER_UPDATE_SUCCESS",
    "INVOICE_CREATE_FAIL": "INVOICE_CREATE_FAIL",
    "INVOICE_CREATE_SUCCESS": "INVOICE_CREATE_SUCCESS",
    "SUBMISSION_READY": "SUBMISSION_READY",
    "VENUE_CREATE_FAIL": "VENUE_CREATE_FAIL",
    "VENUE_CREATE_SUCCESS": "VENUE_CREATE_SUCCESS",
    "VENUE_UPDATE_FAIL": "VENUE_UPDATE_FAIL",
    "VENUE_UPDATE_SUCCESS": "VENUE_UPDATE_SUCCESS"
  }
}
